import { Component, EventEmitter, Inject, Injectable, OnInit, Output, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { AppService } from '@app/_core/services/app.service';
import { DialerService } from '@app/_core/services/dialer.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { EMPTY } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
declare const Twilio: any;
import { APP_BASE_HREF } from '@angular/common';
import { HttpClient } from '@angular/common/http';
//import { HeaderComponent } from '@app/_core/components/header/header.component';
import { Utils } from '@app/_core/helper/Utils';
import { Device } from '@twilio/voice-sdk';
//import { BehaviorSubject } from 'rxjs';
import { customFunc } from '../../../../assets/custom.js';
//import { CaseDetailComponent } from 'src/app/pages/queue/common/case-detail/case-detail.component';
import { PredictiveWaitBlocker } from 'src/app/pages/queue/dialer/PredictiveWaitBlocker';
import { Queue } from 'src/app/pages/queue/dialer/Queue';
import { Dialog } from 'src/app/pages/queue/dialer/dialog';
//import { CommunicationHub } from 'src/app/pages/hubs/tm/CommunicationHub';
import { HubService } from 'src/app/pages/hubs/common/HubService';
import { ConfirmDialogComponent } from 'src/app/pages/common/confirm-dialog/confirm-dialog.component';
/*import { TransferWindowComponent } from 'src/app/pages/common/transfer-window/transfer-window.component';*/
import { UserService } from '@app/_core/services/user.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { WindowsWrapperService } from '@app/_core/services/windows-wrapper.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { MessageDialogComponent } from '@app/pages/common/message-dialog/message-dialog.component';
import { LoaderService } from 'src/app/_core/services/loader.service';
import { ProfileInfoService } from 'src/app/_core/services/profile-info.service';
import { TranscriptService } from 'src/app/_core/services/transcript-service.service';
import { ConfigService } from '@app/config.services';
import { TwilioVoiceService, IncomingCallInfo, QualityWarning, TwilioDeviceStatus } from '@app/_core/services/twilio-voice.service';
let retryCount: number = 0;
let maxRetry: number = 2;
let softPhoneInitializing = false;
let messagePreviewing = false;
let messagePreviewClient = null;
let messagePreviewOnConnect = null;
let messagePreviewContent = null;
let messagePreviewOnDisconnect = null;
let softPhoneBlocker = null;
let refreshBlocker = null;
let phoneClient = 'Twilio'; //cls.QBRSecurity().GetDefaultPhoneClient(),//ONV-1218- Code changes done by 288293(Sadhesh)
let phoneController = null;
let manager = null;
let softPhoneCallback = null;
let waitForCallPending = false,
  redial = false,
  resumeInteraction = false,
  callSid = null,
  autoCall = false,
  isGroupTransfer = false,
  groupTransferComplete = false,
  isGroupTransfer_phnctrl = false,
  groupTransferComplete_phnctrl = false,
  isCallConnected = false,
  ispredictiveopen = false;
let sub: any;
let sub1: any;
let sub2: any;
let call: any;
type searchParameters = {
  type: string;
  value: string;
};
@Injectable({ providedIn: 'root' })
@Component({
  template: '',
})
export class MainControllerComponent { 
  searchParams: any = [];
  innerHeight = 10;
  searchResult: any = [];
  countData: any = 0;
  selectedData: any = {};
  addSearchParameterCount: any = 0;
  addSearchParameterArray: any = [];
  selectedParameters: any = [];
  callConnected: boolean = false;
  waitingForInboundCall: boolean = true;
  userHasBeenWarned: boolean = false;
  phoneNo: any;
  callStatus: any;
  showDialer: boolean = false;
  showWaitingForcallWindow: boolean = false;
  showCallDurationWindow: boolean = false;
  twClient: any;
  callEnded: boolean;
  connection: any;
  queueDialerType: any;
  queueColumns: any;
  queueColumnValues: any = [];
  enableAnswerCallBtn: boolean = false;
  inboundCallDetails: any;
  callId: any = '';
  ActionItemID: any = '';
  selectedInboundCall: any;
  selectedQueueId: any;
  device: any;
  token: any;
  twilioOptions: any;
  callTimer: any;
  clientAbbreviation: any = '';
  TwilioConnection: any;
  ShowManualInboundcallAlert: boolean = false;
  newCallSnd = new Audio('https://common.cts-connect.com/Audio/ding-ding.ogg');
  IncomingCallAlerttext: any = '';
  postCall: boolean = false;
  countdownField: any = '';
  callAlertInterval: any = null;
  actionItemCheckStatusInterval: any;
  groupTransferCheckTimeout: any;
  twilioTokenUpdating: boolean = false;
  softPhone: boolean = false;
  isOutbound = false;
  queueID = null;
  automatedInbound = false;
  automatedQueue = false;
  predictiveQueue = false;
  progressiveQueue = false;
  interactionType = null;
  callInProgress = false;
  numberCalled = null;
  userDetailsData = undefined;
  inbound = false;
  Predictive_inbound = false;
  //isGroupTransfer = false;
  groupTransferComplete = false;
  callPrompt = null;
  callComplete = false;
  statusFailures = 0;
  callIsConnected = false;
  disconnectTimeout = null;
  checkConnectedTimer = null;
  checkCallConnected_retryCount: number = 0;
  checkCallConnected_maxRetry: number = 2;
  dialerType = 'Manual';
  postCallTimeout = 0;
  postCallTimeoutRemaining = 0;
  postCallTimeoutInterval = null;
  postCallTimeoutAlert = false;
  postCallTimeoutText = '';
  requestMoreTimeBtn = false;
  isRedial = false;
  redialAlert = null;
  lastqueue = null;
  autoAdvanceEnabled = true;
  softphoneFailures = 0;
  conferenceID = null;
  automatedCall = false;
  curUserStatus = false;
  cachedStatus = null;
  automatedExternal = false;
  manualExternal = false;
  blendedLastQueue = null;
  pageRefresh = true;
  isPageInitCompleted = false;
  isDialerCancelled = false;
  statusSet = false;
  interactionID: any;
  parentCallStatus: any;
  outgoingCallStatus: any;
  phoneEnabled: any;
  phoneNumber: any;
  contactName: any;
  callActive: any;
  holdBtnEnabled: any;
  isAttendedTransfer: any;
  selfInitiated: any;
  softPhoneActive: any;
  muteBtn_enabled: any;
  waitingForCallToComplete = false;
  callTransferred = false;
  transferCancelledBySender = false;
  hangUpBtn: any;
  pendingTransferComplete = false;
  isTransferActive: any;
  isInternalTransfer: false;
  isAway = false;
  isPersonalCall = false;
  isConferenceCall: any;
  conference: any;
  holdBtn_enabled: any;
  transfersBtn_enabled: any;
  keypadBtn_enabled: any;
  callDuration: any;
  callData: any;
  onHold = false;
  transfer: any;
  interactionName: any;
  queueType: any;
  queueName: any;
  QueueInteractionType: any;
  callers: any;
  isListeningIn = false;
  ListenInisMuted = false;
  actionItemToReturn: any;
  activityId: any;
  isTest: boolean = false;
  // selectedType: any=[];
  // selectedValue: any=[];
  //private inboundComponent: InboundComponent;
  isSoftphoneErrorOccurred = false;
  isInternalCallConnected = false;
  //isDialogController = false;
  requestType: any = '';
  isSetActionItemCompleted: boolean = false;
  callDuraton: any = 0;
  formattedCallDuration: any;
  enterRecord: any = '';
  transferCaseID: any;
  isUserSelected = false;
  isCaseDetail = false;
  twilioTokenErrors = 0;
  isFreeDialer: boolean = false;
  CalleeeUserID: any;
  enableDialManuallyButton = false;
  automated = false;
  predictive = false;
  keypadMode = false;
  hideCallPrompt = false;
  keypadCallPrompt = false;
  QueueInfoDetail: any;
  IsCallPromptReadOnly: boolean = false;
  disableCallPromptControls: boolean = false;
  backBtn: boolean = false;
  // Phone validation modal properties
  showValidationModal: boolean = false;
  showSearchDialog: boolean = false;
  validationModalDisplay: string = 'none';
  validationErrorMessage: string = '';
  currentRecordUserID: string = null;
  LastCallCompletedTime: any = null;
  isSubmitfailurePopupdisplayed: boolean = false;
  isPostcalltranscription: boolean = false;
  Iscallanswered = false;
  IsCaseUserUnmapped = null;
  IsUnknownContact = false;
  UnmappedCaseID = '';
  UnmappedUserID = '';
  HideUnknownContact = false;
  IsReadOnlyCase = false;
  isTransfercallInitiated = false;
  enableTemplateButton: boolean = false;
  receiveSummary: boolean = false;
  timeoutRef: any;
  audioInputDeviceId = 'default';
  audioOutputDeviceId = 'default';
  checkCallStatusTimeout1: any;
  checkCallStatusTimeout2: any;
  errorCleanupTimer: any;
  waitingTimeout: any;
  constructor(
    private queueServices: QueuesService,
    private router: Router,
    private appService: AppService,
    private tmQueueService: TmQueueService,
    private dialerService: DialerService,
    private predictiveWaitBlocker: PredictiveWaitBlocker,
    private queue: Queue,
    private dialog: Dialog,
    private hubService: HubService,
    /*private transferWindowComponent: TransferWindowComponent,*/
    private userService: UserService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private http: HttpClient,
    //private headerComponent: HeaderComponent,
    private confirmDialogComponent: ConfirmDialogComponent,
    // private caseDetailComponent: CaseDetailComponent,
    private webStorageService: WebStorageService,
    private WindowsWrapper: WindowsWrapperService,
    private modalService: BsModalService,
    private loaderService: LoaderService,
    private ProfileInfo: ProfileInfoService,
    private transcriptService: TranscriptService,
    private configService: ConfigService,
    private twilioVoice: TwilioVoiceService,
    private zone: NgZone,
    private utils: Utils
  ) { 

      // In ngOnInit() - TEMPORARY
      //(window as any).testTwilioError =
      //    (code: number, times: number) => this.testTwilioError(code, times);

    this.dialerService.IsFreeDialer.subscribe(value => {
      this.isFreeDialer = value;
    });
    this.hubService.InboundCallEvents.subscribe((value: any) => {
      console.log('main cntrl events', value.eventName);
      if (value && value.eventName == 'INBOUND_CALL') {
        // _userDetails = value.data;
        console.log('main cntrl inbound received', value.data);
        //this.eInboundCallHandler(value.data);
        //this.isDialogController = true;
        //this.isInternalTransfer = false;
      } else if (value && value.eventName == 'CALL_Ended') {
        // _userDetails = value.data;
        console.log('main cntrl CALL_Ended received', value.data);
        this.eRealTimeCallEndedHandler(value.data);
        if (this.isPostcalltranscription) {
          console.log('Post call transcription completed');
          this.appService.EnableTranscriptTab(false);
          this.appService.SetTranscriptId(this.interactionID, true);//this.interactionID
        }
        if (!this.receiveSummary) {
          this.timeoutRef = setTimeout(() => {
            if (!this.receiveSummary && this.enableTemplateButton) {
              this.appService.setEnableTemplateButton(true && this.enableTemplateButton);
            }
            //console.log('Background task finished');
            clearTimeout(this.timeoutRef);
          }, 10000);
        }
      } else if (value && value.eventName == 'MESSAGE_RECEIVED') {
        // _userDetails = value.data;
        console.log('main cntrl message received', value.data);
        this.softPhoneProcessMessage(value.data);
      } else if (value && value.eventName == 'SUBMIT_CALL') {
        // _userDetails = value.data;
        console.log('main cntrl submit call received', value.data);
        this.eSubmitHandler();
      } else if (value && value.eventName == 'REMOTE_LOGGEDOFF') {
        // _userDetails = value.data;
        console.log('Remote logoff event triggered.');
        this.eRemoteLoggedOffHandler(value.data);
      } else if (value && value.eventName == 'RECEIVE_LIVETRANSCRIPT') {
        if (!this.callEnded && value.data?.Transcript != null) {
          this.enableTemplateButton = true;
          this.appService.EnableTranscriptTab(false);
          //console.log('Live Transcript event triggered.', value.data);
          this.transcriptService.setSentences(value.data, null);
        }
        else if (value.data?.Transcript == null && value.data?.SentenceIndex == 1) {
          this.TranscriptReset();
          this.enableTemplateButton = false;
          this.receiveSummary = false;
        }
      } else if (value && value.eventName == 'RECEIVE_CALLANALYTICS') {
        //console.log('Live Transcript event triggered.', value.data);
        this.transcriptService.setSentences(null, value.data);
        this.receiveSummary = true;
        // Enable Notes Template button 
        this.appService.setEnableTemplateButton(true && this.enableTemplateButton);
      }
      else if (value && value.eventName == 'SENDCALL_FAILUREALERT') {
        console.log('SENDCALL_FAILUREALERT triggered.', value.data);
        if (this.QueueInteractionType == 'Blended' || this.QueueInteractionType == 'Outbound' || this.QueueInteractionType == 'Search' || this.QueueInteractionType == 'Keypad') {
          this.showValidationError(value.data == 'failed' ? 'Wrong/Bad Number' : value.data, true, 'block', true);
        }
      }
      else if (value && value.eventName == 'SENDDEVICE_FAILUREALERT') {
          console.log('SENDDEVICE_FAILUREALERT triggered.', value.data);
          this.handleAgentStatusDisconnect(value.data);
      }
    });

    this.appService.numberPadValue.subscribe((value: any) => {
      //console.log(value, 'num');

      if (value) {
        this.numberPadKeyPressedHandler(value);
      }
    }); 
    this.appService.selectedQueueType.subscribe((type: any) => {
      this.queueType = type;
    });
    this.dialerService.callEnded.subscribe((val: boolean) => {
      if (val) {
        this.endCall_main(false, false);
      }
      // if (val) this.hangUp();
    });
     
    this.appService.isMenulinkClicked.subscribe((val: any) => {
      if (val) {
        this.Predictiveclose();
        this.disconnectTwilio();
      }
    });
    this.dialerService.isResumeCalling.subscribe((value: any) => {
      if (value) {
        this.isDialerCancelled = false;
        this.SetDialerCancelledStatus(false);
        if (!this.GetIsPageLoadCompleted()) {
          // this.isPageInitCompleted = true;
          this.SetIsPageLoadCompleted(true);

          if (!this.device) {
            this.initializeSoftPhone();
          }
          this.resumeCalling();
        }
      }

      //this.dialerService.isResumeCalling.unsubscribe();
    });
    this.dialerService.muteMic.subscribe(v => this.twilioVoice.mute(!!v));
     
    this.dialerService.onHold.subscribe((val: boolean) => {
      if (val) {
        var callID = '';
        if (this.dialerService.getIsFreeDialer()) {
          callID = this.queueServices.getChildCallID();
        }
        else {
          callID = this.queueServices.getCallID();
        }

        this.tmQueueService.holdCall(callID, true).subscribe(data => {
          // console.log(data);
          this.onHold = true;
        });
      }
    });

    this.dialerService.resumeCall.subscribe((val: boolean) => {
      if (val) {
        var callID = '';
        if (this.dialerService.getIsFreeDialer()) {
          callID = this.queueServices.getChildCallID();
        }
        else {
          callID = this.queueServices.getCallID();
        }

        this.tmQueueService.resumeCall(callID, true, false, '').subscribe(data => {
          //console.log(data);
          this.onHold = false;
        });
      }
    });
   
    this.dialerService.isDialerCancel.subscribe((isCancelled: boolean) => {
    if (!isCancelled) return;

    const deviceState = this.twilioVoice.getDeviceState();
    const hasActiveCall = this.twilioVoice.hasActiveCall();
    const canDisconnectTwilio =
      this.twilioWired &&
      deviceState !== 'idle' &&  
      deviceState !== 'destroyed' &&
      hasActiveCall;
      this.dialerService.setPredictiveModalState(false);
     console.log('[Dialer] Cancel requested', {
      isCancelled, 
      twilioWired: this.twilioWired,
      deviceState,
      hasActiveCall:hasActiveCall,
      canDisconnectTwilio,
    });
    this.dialerService.setPredictiveModalState(false);
    if (canDisconnectTwilio) {
      try {
        this.twilioVoice.hangup();
      } catch (error) {
        console.error(
          '[Dialer] Error while disconnecting Twilio call',
          error,
        );
      }
    }
    this.resetDialerAfterCancellation();
  });

    this.appService.actionItemId.subscribe(value => {
      if (value) {
        this.actionItemToReturn = value;
      }
    });
    this.appService.activityId.subscribe(value => {
      this.activityId = value;
    });
    this.appService.transferCaseID.subscribe(value => {
      this.transferCaseID = value;
    });
  }
  private resetDialerAfterCancellation(): void {
    this.SetDialerCancelledStatus(true);
    this.isDialerCancelled = true;
  
    this.dialerService.setConnections(false);
    this.dialerService.setCallDisconnected(false);
    this.dialerService.setShowDialer(false);
    this.dialerService.setCustomShowDialer(false);
  
    this.showPhoneMessaging('');
    this.SetIsPageLoadCompleted(false);
  
    this.Predictiveclose();
  }
  ngOnInit(): void { 
    if (this.pageRefresh && !this.GetIsPageLoadCompleted()) this.doPageInit();

    this.dialerService.setPredictiveModalState(false);
  }
  ngOnDestroy() {
    this.timeoutRef && clearTimeout(this.timeoutRef);
    this.checkConnectedTimer && clearTimeout(this.checkConnectedTimer);
    this.postCallTimeoutInterval && clearTimeout(this.postCallTimeoutInterval);
    this.groupTransferCheckTimeout && clearTimeout(this.groupTransferCheckTimeout);
    this.checkCallStatusTimeout1 && clearTimeout(this.checkCallStatusTimeout1);
    this.checkCallStatusTimeout2 && clearTimeout(this.checkCallStatusTimeout2);
    this.callTimer && clearInterval(this.callTimer);
    this.callAlertInterval && clearInterval(this.callAlertInterval);
    this.actionItemCheckStatusInterval && clearInterval(this.actionItemCheckStatusInterval);
    if (this.errorCleanupTimer) {clearInterval(this.errorCleanupTimer); }
  }
  GetIsPageLoadCompleted() {
    let p1 = this.queueServices.getIsPageLoadCompleted();
    return p1;
  }
  SetIsPageLoadCompleted(val) {
    this.queueServices.setIsPageLoadCompleted(val);
  }
  GetDialerCancelledStatus() {
    let p1 = this.dialerService.getDialerCancelledStatus();
    return p1;
  }
  SetDialerCancelledStatus(val) {
    this.dialerService.setDialerCancelledStatus(val);
  }
  doPageInit() {
    // this.isPageInitCompleted = true;
    // this.SetIsPageLoadCompleted(true);
    this.clientAbbreviation = Utils.fetch('clientAbbreviation');
    //console.log(this.clientAbbreviation);
    this.selectedQueueId = this.queueServices.getselectedQueueId();

    //this.selectedQueueId = localStorage.getItem('qid');
    //console.log('Inbound Selected Queue ID:' + this.selectedQueueId);
    // this.isInboundCallConnected();
    this.getQueueInfo(this.selectedQueueId);
    this.getOptionsForQueue(this.selectedQueueId);
    this.releaseLocks();
    //this.setUserStatus(6, this.selectedQueueId);
    this.setCurrentQueue(this.selectedQueueId);
    this.getInboundStatus(this.selectedQueueId, false);
    this.initializeSoftPhone();

    //this.setCurrentActionItem(this.selectedQueueId);
    this.getExternalNumbersByActivity(this.selectedQueueId);
    this.getFailureDispositions();
    //this.getUserStatus(this.selectedQueueId);
    this.getSearchParams(); 
    this.tmQueueService.getQueueColumns(this.selectedQueueId).subscribe(data => {
      // display data in grid
      // console.log("getQueueColumns response", data)
      this.queueColumns = data.Response.Data;
      // this.headerComponent.getBasicAgentStats();
    });

    this.getVoicemailCountByStatus(-1, 'new'); 

    this.dialerService.resetTimer.subscribe((val: boolean) => {
      if (val) {
        clearInterval(this.callTimer);
      }
    });
 
  }

  getSearchParams() {
    this.queueServices
      .GetSearchParams()
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetSearchParams');
          if (isValid) {
            // console.log("this.dataToDisplay",data)
            this.searchParams = data.Response.Data.SearchParameters;

            const searchObject: searchParameters = {
              type: this.searchParams[0].Label,
              value: '',
            };

            this.addSearchParameterArray.push(searchObject);
            // this.selectedType[0]=this.searchParams[0].Label;
            // this.filteredData = this.queueList;
            // this.dataToDisplay = this.queueList;
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }

  searchRecords() {
    //console.log(this.addSearchParameterArray)
    this.queueServices
      .findRecord(this.addSearchParameterArray)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'FindRecord');
          if (isValid) {
            this.searchResult = data;
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }

  countChange(data) {
    // console.log("data",data);
    this.countData = data;
    //console.log(this.countData)
    //console.log(this.searchResult?.Response?.Data?.length)
  }

  dataChange(data) {
    this.selectedData = data;
  }

  getCaseDetails() {
    // console.log("this.searchResult",this.selectedData)
    const menuName = this.appService.getCurrentMenu().value;
    const url = '-' + this.queueServices.getCaseDetails(menuName, this.selectedData);
    // console.log(this.router.url,url)
    this.router.navigateByUrl(this.router.url + url);
    //this.router.navigateByUrl(this.router.url + '/caseDetails')
    //this.router.navigate(['caseDetails'])
  }

  addSearchParameter() {
    const searchObject: searchParameters = {
      type: '',
      value: '',
    };
    this.addSearchParameterArray.push(searchObject); 
  }

  removeSearchParameter() {
    this.addSearchParameterArray.pop();
  }

  getOptionsForQueue(queueId) {
    this.tmQueueService.getOptionsForQueue(queueId).subscribe(data => {
      //console.log("getOptionsForQueue response", data);
    });
  }

  getQueueInfo(queueId: any) {
    this.tmQueueService.getQueueInfo(queueId).subscribe(data => {
      // console.log("getQueueInfo response", data);
      const queueDialerType = data.Response.Data.DialerType;
      this.queueDialerType = queueDialerType;
      if (queueDialerType === 'AutomatedInbound') {
        // Manual, Progressive
        this.automatedInbound = queueDialerType == 'AutomatedInbound';
        this.dialerService.setDeviceReady(true);
        this.dialerService.setConnections(true);
        //this.dialerService.setWaitingForInboundCall(true);
        this.automatedQueue = true;
        //setInterval(() => {
        //this.isInboundCallConnected();
        //this.waitingForCall(queueId, null);
        // this.GetqueueDetails(queueId);
        this.getInboundStatus(queueId, false);
        //}, 2000);
      } else if (queueDialerType === 'Manual') {
        // call getInboundCalls API

        this.callTimer = setInterval(() => {
          this.getInboundStatus(queueId, false);
          this.getInboundCalls(queueId, false);
        }, 10000);
      } else if (queueDialerType === 'Progressive') {
        // @TODO: TBD
      }
    });
  }

  onRowSelect(data: any) {
    // console.log('row select', data);
    const tempArr = data.ActionItemID.split('_');
    this.callId = tempArr[1];
    this.queueServices.setCallID(tempArr[1]);
    this.selectedInboundCall = data;
    this.ActionItemID = data.ActionItemID;
    this.enableAnswerCallBtn = true;
    //console.log('enableAnswerCallBtn', this.enableAnswerCallBtn);
    //this.answerCall();
  }

   
  inboundCallAlert = function (callDetails) {
     console.log('inboundCallAlert', callDetails);
    this.ShowManualInboundcallAlert = true;
    let Number = callDetails.find(i => i.key === 'number').value,
      name = Utils.cleanString(callDetails.find(i => i.key === 'name').value),
      queue = Utils.cleanString(callDetails.find(i => i.key === 'queue').value),
      _callId = callDetails.find(i => i.key === 'callID').value,
      queuedTime = this.convertServerDate(callDetails.find(i => i.key === 'queuedTime').value),
      //now = this.convertServerDate(callDetails.find(i => i.key === 'CurrentTime').value),
      now = 0,
      secondsRemaining = Math.floor(Math.min(60, 90 - (now - queuedTime) / 1000)),
      conference = callDetails.find(i => i.key === 'conference').value;

    this.callId = _callId;
    //this.queueServices.setCallID(_callId);
    this.newCallSnd.play();
    if (!conference) {
      this.countdownField = '00:' + (secondsRemaining < 10 ? '0' : '') + secondsRemaining;
      // btnView.addSubView(countdownField);
    }
    this.IncomingCallAlerttext =
      'Incoming ' +
      (conference ? 'conference with ' : 'call from ') +
      (Number == null ? '' : Number) +
      (name && name != '' ? ' - ' + name : '') +
      (queue && queue != '' ? ' (' + queue + ')' : '') +
      (this.postCall ? ' - Finish the current call to answer.' : '');
    
    if (this.callAlertInterval) clearInterval(this.callAlertInterval);
    this.callAlertInterval = setInterval(() => {
      secondsRemaining--;
      this.countdownField = '00:' + (secondsRemaining < 10 ? '0' : '') + secondsRemaining;
      if (secondsRemaining <= 0) {
        // notification.close();
        clearInterval(this.callAlertInterval);
        this.ShowManualInboundcallAlert = false;
        this.rejectInboundCall(this.queueServices.getCallID());
        // im.InteractionService.instance().RejectCall({ callID: call.CallID };
      }
    }, 1000);
  };
  convertServerDate = function (date) {
    if (!date) return null;
    const dateFormat = /\/Date\(.*\)\//gi;
    if (dateFormat.test(date)) return new Date(parseInt(date.replace('/Date(', '').replace(')/', '')));
    else return new Date(date);
  };

  eInboundCallHandler = function (callDetails) {
    this.inboundCallAlert(callDetails);
  };

  eRealTimeCallEndedHandler = function (e) { 
    this.SetIsPageLoadCompleted(false);
    this.queueServices.setCaseDetails_ENABLECONTROLS(false);
  };

  rejectCall() {
    console.log('Call was rejected')
    this.rejectInboundCall(this.queueServices.getCallID());
    this.dialerService.setcallEnded(true);
    this.ShowManualInboundcallAlert = false;
    if (this.callAlertInterval) clearInterval(this.callAlertInterval);
  }
  rejectInboundCall(_callId) {
    this.tmQueueService.rejectCall(_callId).subscribe(data => {
      //console.log("isInboundCallConnected response", data);
    });
  }
  answerInboundNextCall1() {
    this.setCurrentActionItem(this.selectedQueueId, this.ActionItemID);
    this.dialerService.setShowDialer(true);
    // Answer inbound call API
    this.tmQueueService.answerInboundCall(this.queueServices.getCallID(), this.selectedQueueId).subscribe(data => {
      // console.log('answerInboundCall response', data);
      this.dialerService.setPhoneNo(data.Response.Data.PhoneNumber); // for testing
      this.dialerService.setCallConnected(true); // Show timer
      this.appService.setUserStatus(5, this.selectedQueueId);
      this.appService.setActionItemId(
        this.selectedQueueId + '-' + data.Response.Data.UserID + '-' + data.Response.Data.CaseID
      );
      this.setCurrentCallee(data.Response.Data.UserID);
      this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/caseDetails']);
    });
  }
  setCurrentCallee(userID) {
    this.tmQueueService.setCurrentCallee(this.queueServices.getCallID(), userID).subscribe(data => {
      // console.log('setCurrentCallee response', data);
    });
  }

  waitingForCall1(queueId, agentCallId) {
    this.tmQueueService.waitingForCall(queueId, agentCallId).subscribe(data => {
      //console.log("waitingForCall response", data);
      this.callId = data.Response.Data.CallID;
      // this.headerComponent.getBasicAgentStats();
      //this.isInboundCallConnected();
    });
  }

  isInboundCallConnected() {
    this.tmQueueService.isInboundCallConnected().subscribe(data => {
      //console.log("isInboundCallConnected response", data);
    });
  }

  getInboundStatus(queueId, showLoader) {
    this.tmQueueService.getInboundStatus(queueId, showLoader).subscribe(data => {
      //console.log("getInboundStatus response", data);
    });
  }

  getInboundCalls(queueId, showLoader) {
    this.tmQueueService.getInboundCalls(queueId, showLoader).subscribe(data => {
      // button enable logic
      //console.log("getInboundCalls response", data);      
      this.inboundCallDetails = data.Response.Data.Items;
      if (data.Response.Data.TotalItems > 0) {
        //enable answer button
        this.enableAnswerCallBtn = true;
      }
    });
  }

  releaseLocks() {
    this.tmQueueService.releaseLocks().subscribe(data => {
      //console.log("releaseLocks response", data);
    });
  }

  setCurrentQueue(queueId) {
    this.tmQueueService.setCurrentQueue(queueId).subscribe(data => {
      //console.log("setCurrentQueue response", data);
    });
  } 
  getExternalNumbersByActivity(queueId) {
    this.tmQueueService.getExternalNumbersByActivity(queueId).subscribe(data => {
      //console.log("GetExternalNumbersByActivity response", data);
    });
  }

  getFailureDispositions() {
    this.tmQueueService.getFailureDispositions().subscribe(data => {
      //console.log("getFailureDispositions response", data);
    });
  }

  getUserStatus(queueId) {
    this.tmQueueService.getUserStatus(queueId).subscribe(data => {
      //console.log("getUserStatus response", data);
    });
  }

  setCurrentActionItem(queueId, ActionItemID) {
    this.tmQueueService.setCurrentActionItem(queueId, ActionItemID).subscribe(data => {
      //console.log("setCurrentActionItem response", data);
      //this.dialerService.setShowDialer(true);
      let EnableAICaseNotesTemplate = data.Response.Data?.EnableAICaseNotesTemplate || false;
      this.appService.setEnableAICaseNotesTemplate(EnableAICaseNotesTemplate);
      // this.appService.setEnableTemplateButton(EnableAICaseNotesTemplate);
    });
  }

  getVoicemailCountByStatus(agentID, status) {
    this.tmQueueService.getVoicemailCountByStatus(agentID, status).subscribe(data => {
      //console.log("getVoicemailCountByStatus response", data);
    });
  }
  twilioClientInvited(info: IncomingCallInfo) {
    const conn = info.call;
    const answerCall = (callData: any) => { 
      this.twilioVoice.acceptCall({call:conn,callData});            // 'accept' stream drives softPhoneCallAccepted
      if (callData && callData.isIgnore) this.endCall_main(false, false);
    };
    if (info.conferenceId) {
      this.tmQueueService.GetInternalCallInfo(info.conferenceId, info.callSid).subscribe(data => {        
        const agentInfo = data.Response.Data; 
        const tempData = { UserID: agentInfo.UserID, InteractionID: agentInfo.InteractionID };
        this.queueServices.setTransferFlag(true);
        this.confirmDialogComponent.confirmdialog(
          '', 'Incoming internal call from ' + (agentInfo.FullName || 'unknown agent'),
          'Accept', 'Decline', tempData
        ).then(confirmed => {
          if (confirmed) {
            this.dialerService.setCurrentStatusid(3);
            this.dialerService.setIsTransferCallRejected(false);
            this.tmQueueService.IsTransferCancelled(agentInfo.UserID, agentInfo.InteractionID).subscribe(res => {
              if (!res.Response.Data) {
                answerCall({ number: agentInfo.FullName, contact: agentInfo.FullName, inbound: false, isInternalTransfer: true, isIgnore: false });
              } else {
                this.softPhoneInternalCallEnded();
                this.showMessageModalDialog('The internal call from ' + (agentInfo.FullName || 'unknown agent') + ' has ended.');
              }
            });
          } else {
            this.twilioVoice.rejectCall(conn);
            this.queueServices.setTransferFlag(false);
            this.dialerService.setIsTransferCallRejected(true);
          }
        }).catch(() => console.log('User dismissed the internal-call dialog'));
        this.newCallSnd.play();
      });
    } else {
      answerCall(null);
    }
  } 
  updateCallQualityUI = function (message, type, isResolved) {     
    console.log({message, type,isResolved}); 
  }; 
  
  numberPadKeyPressedHandler(val) { this.twilioVoice.sendDigits(val || '0'); }
  showMessageModalDialog(messageText) {
    const initialState = { message: messageText, showIcon: false };
    const config: ModalOptions = {
      class: 'modal-sm modal-dialog-centered',
      ignoreBackdropClick: true,
      keyboard: false,
      initialState: initialState,
    };

    let modalRef = this.modalService.show(MessageDialogComponent, config);
    //modalRef.content.event.subscribe((result: any) => {});
  }
  resetSoftphoneinitialize() {
    softPhoneInitializing = false;
  } 
  //New implementation
  async initializeSoftPhone() {
    const loginParams = this.webStorageService.getItemFromSessionStorage('loginParams');
    if (!loginParams.UseSoftPhone) return;
    if (softPhoneInitializing) return;
    softPhoneInitializing = true;
    this.startErrorMapCleanup(); //Calling to cleanup the error map for twilio errors which are not handled properly in the code.
    this.softPhone = true;
    if (this.queueDialerType != 'AutomatedInbound') this.setAllDialerWindowStatus(false, true, false);
    this.showPhoneMessaging('The soft phone is starting up. Please wait...');
  
    this.wireTwilioEvents();
    // this.callQuality.start((key, payload) => this.userService.LogConsoleErrors(key, payload).subscribe(() => {}));
   
    //  Actually start the device on first load.
    try {
      await this.startTwilioDevice();
    } catch (e) {
      console.error('[TwilioVoice] init failed', e);
    } finally {
      softPhoneInitializing = false;
    }
    this.validateQueueDialerType();
  }
  
  /**
   * Shared init used by BOTH first load and reInitHook (wake-from-sleep).
   * Returns a real Promise that resolves only after Device is initialized,
   * so hardReconnect()'s await + retry/backoff works correctly.
   */
  private startTwilioDevice(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.tmQueueService.GetTwilioToken().subscribe({
        next: async (response: any) => {
          try {
            const token = response.Response.Data.Token;
            const TurnNTS = response.Response.Data.TurnIce;   // raw NTS JSON from backend
            this.appService.setSoftPhoneStatus('Connecting...');
  
            await this.twilioVoice.initialize(
              token,
              // token provider (refresh)
              () => new Promise<string>((res, rej) =>
                this.tmQueueService.GetClientTokenUpdate().subscribe((r: any) => res(r.Response.Data), rej)),
              // ICE provider: map the raw NTS JSON -> RTCIceServer[]
              () => Promise.resolve(this.mapTurnIce(TurnNTS)),
            );
            resolve();
          } catch (e) {
            reject(e);
          }
        },
        error: (err) => reject(err),
      });
    });
  }
  
  /** Normalize Twilio NTS JSON into RTCIceServer[] (handles ice_servers, url/urls, null creds). */
  private mapTurnIce(turnIce: any): RTCIceServer[] {
    const raw: any[] = turnIce?.ice_servers ?? turnIce?.iceServers ?? [];
    return raw.map((s: any) => {
      const urls = s.urls ?? s.url;
      const server: RTCIceServer = { urls: Array.isArray(urls) ? urls : [urls] };
      if (s.username)   server.username   = s.username;      // skipped for STUN (null)
      const cred = s.credential ?? s.password;
      if (cred)         server.credential = cred;            // skipped for STUN (null)
      return server;
    }).filter(s => !!s.urls);
  }
  //end
  private twilioWired = false;
private wireTwilioEvents() {
  if (this.twilioWired) return;
  this.twilioWired = true;

  this.twilioVoice.status$.subscribe((status: TwilioDeviceStatus) => {    
    if (status === 'registered') { this.dialerService.setDeviceReady(true); this.softPhoneRegistered(); }
    //if (status === 'unregistered') this.softPhoneUnregistered('Network Interruption'); 
    if(status === 'destroyed') {this.softPhoneCallEnded();}
  });

  this.twilioVoice.incoming$.subscribe((info: IncomingCallInfo) => {
    this.connection = info.call;
    this.dialerService.setStatusMessage('On Call (Active)');
    this.twilioClientInvited(info);
  });

  this.twilioVoice.accepted$.subscribe(({ call, callData }) => {
    //this.callQuality.setContext(this.interactionID, call.parameters['CallSid']);   
    this.softPhoneCallAccepted(call.customParameters.get('Message') ?? null, callData);
  });

  this.twilioVoice.ended$.subscribe(async () => {
    await this.twilioVoice.unsetInputDevice();
    if (this.isSoftphoneErrorOccurred) this.setPredictiveOpen(true);
    this.softPhoneCallEnded();
  });

  this.twilioVoice.reconnecting$.subscribe(() => this.updateCallQualityUI('Reconnecting... please hold.', 'network', true));
  this.twilioVoice.reconnected$.subscribe(() => this.updateCallQualityUI('Reconnected successfully.', 'network', false));
  this.twilioVoice.quality$.subscribe((w: QualityWarning) => this.updateCallQualityUI(w.message, w.category, w.active));
    //this.twilioVoice.error$.subscribe(err => this.LogConsoleErrors(err));
    this.twilioVoice.error$.subscribe((err: any) => {
        this.handleTwilioErrorLogging(err);
    });
} 
  resetSoftPhone()   { this.twilioVoice.destroy(); }
  disconnectTwilio() { this.twilioVoice.hangup(); }
  muteUnmuteMic(v)   { this.twilioVoice.mute(!!v); }
  private validateQueueDialerType(): void {
    const allowedDialerTypes = ['AutomatedInbound', 'Progressive'];
    const dialerType = (this.queueDialerType ?? '').trim();
  
    if (!dialerType || !allowedDialerTypes.includes(dialerType)) {
      this.setAllDialerWindowStatus(false, false, false);
    }
  }
  writeJsFile(content: any): void {
    // JS Cannot write file, it has to be done from BE.     
  }

  executeExternalFunction(funcName: string, args: any[]) {
    console.log('Calling executeExternalFunction', funcName);
    if (customFunc[funcName] && typeof customFunc[funcName] === 'function') {
      customFunc[funcName].apply(funcName, args);
    } else {
      console.error(`Function ${funcName} does not exist in customFunc.`);
    }
  }

  //Automated Call Start

  GetqueueDetails(queueId: any, isautomatedQueue: any) {
    //this.getCurrentQueueInfo(queueId);
    return new Promise((resolve, reject) => {
      this.tmQueueService.getQueueInfo(queueId).subscribe(data => {
        // console.log('getCurrentQueueInfo', data);
        this.appService.setRecordingAgentScreen(data.Response.Data.RecordAgentScreen);
        this.SendPreferences(data.Response.Data.RecordAgentScreen);

        this.QueueInteractionType = data.Response.Data.Type;
        this.queueDialerType = data.Response.Data.DialerType;
        var data: any = {};
        data.navigateURL = '';
        data.dialerType = this.queueDialerType;
        data.interactionType = this.QueueInteractionType;

        if (this.queueDialerType == "Preview" || this.queueDialerType == "Power" || this.queueDialerType == "Keypad") {

          if (this.queueDialerType == "Preview" || this.queueDialerType == "Keypad")//|| cls.cl().main().mainController().userHasBeenWarned())
          {
            data.navigateURL = queueId + '-auto';
          }

        } else if (this.queueDialerType == "Predictive" || this.queueDialerType == "Progressive") {

          data.navigateURL = queueId + '-auto';

        } else if (this.queueDialerType == "AutomatedInbound") {
          data.navigateURL = queueId + '-inbound_auto';

        }


        if (
          this.queueDialerType === 'Manual' &&
          (this.QueueInteractionType == 'Outbound' || this.QueueInteractionType == 'Search') &&
          this.actionItemToReturn
        ) {
          let urlcontent = this.actionItemToReturn; //this.queueID + '-' + (this.inbound ? 'inbound_' : '') + 'i' + this.interactionID + '-0' + (msg.QueueID == this.queueID ? '' : ('-' + this.queueID));

          data.navigateURL = urlcontent;
          this.isSetActionItemCompleted = false;
          groupTransferComplete = false;
          this.CallCurrentActionItems(this.queueServices.getselectedQueueId(), data);
        } else if (
          (this.queueDialerType === 'AutomatedInbound' || this.queueDialerType === 'Progressive' || this.queueDialerType === 'Keypad') &&
          !isautomatedQueue
        ) {
          this.CallCurrentActionItems(queueId, data);
        }
        else if ((this.queueDialerType === 'AutomatedInbound' && this.QueueInteractionType == 'Inbound') || (this.QueueInteractionType == 'Outbound' || this.QueueInteractionType == 'Search') && this.queueServices.getFromSearchQueue()) {
          //this.CallCurrentActionItems(queueId, res);
          // this.setActionItems(queueId, det);
        }
        resolve(data);

      });
    });
     
  }
  setItemsforSalesforce(response, queueType) {
    //this.tmQueueService.setCurrentActionItem(queueId, data.navigateURL).subscribe(response => {
    this.updateToSalesforce(response, queueType)
    //});
  }
  CallCurrentActionItems(queueId: any, data: any) {
    if (data) {
      this.queueDialerType = data.dialerType;
    }
    // console.log('Queue Return: ' + data);
    //this.queueDialerType = queueDialerType;
    if (
      (this.queueDialerType === 'AutomatedInbound' && this.QueueInteractionType == 'Inbound') ||
      this.queueDialerType === 'Progressive'
    ) {
      // Manual, Progressive
      //this.automatedInbound = true;
      //this.automatedQueue = true;
      this.setAutomatedActionItems(queueId, data);
      this.automatedInbound = this.queueDialerType == 'AutomatedInbound';
      this.dialerService.setDeviceReady(true);
      this.dialerService.setConnections(true);
      this.showPhoneMessaging('Initializing...');
      this.setAllDialerWindowStatus(false, true, false);
      // this.dialerService.setWaitingForInboundCall(true);
      this.automatedQueue = true;
      
    } else if (this.queueDialerType === 'Manual' && this.QueueInteractionType == 'Inbound') {
      // call getInboundCalls API
      this.setAutomatedActionItems(queueId, data);
    } else if (
      (this.queueDialerType === 'Manual' || this.queueDialerType === 'Keypad') &&
      (this.QueueInteractionType == 'Search' ||
        this.QueueInteractionType == 'Outbound' ||
        this.QueueInteractionType == 'Blended')
    ) {
      this.setAutomatedActionItems(queueId, data);
    }
   
  }
  setAutomatedActionItems(queueId: any, data: any) {
    this.tmQueueService.setCurrentActionItem(queueId, data.navigateURL).subscribe(response => {
      let EnableAICaseNotesTemplate = response.Response.Data?.EnableAICaseNotesTemplate || false;
      this.appService.setEnableAICaseNotesTemplate(EnableAICaseNotesTemplate);
      //this.appService.setEnableTemplateButton(EnableAICaseNotesTemplate);

      this.requestType = response?.Response?.Data?.RequestType ?? null;
      var dialer_type = response?.Response?.Data?.DialerType;

      this.automatedQueue =
        dialer_type == 'Preview' ||
        dialer_type == 'Power' ||
        dialer_type == 'Progressive' ||
        dialer_type == 'Predictive' ||
        dialer_type == 'AutomatedInbound' ||
        dialer_type == 'AutomatedExternal' ||
        dialer_type == 'Keypad';
      this.progressiveQueue = dialer_type == 'Progressive';
      this.predictiveQueue = dialer_type == 'Predictive';
      this.automatedInbound = dialer_type == 'AutomatedInbound';
      this.automatedExternal = dialer_type == 'AutomatedExternal';
      this.manualExternal = dialer_type == 'ManualExternal';
      

      if (response?.Response?.Data?.Auto && !response.Response.Data.redial && response.Response.Data.CallSid == null) {
        if (this.UserHasBeenWarned() || this.queueDialerType == 'AutomatedInbound') this.waitForCall(queueId);
        else this.showAutomationWarning();

        return;
      }
      this.dialerService.setIVRUserID(response.Response?.Data?.UserID != -1 ? response.Response?.Data?.UserID : null);
      autoCall = response?.Response?.Data?.Auto;
      this.enterRecord = this.convertServerDate(response?.Response?.Data?.EnterRecord);
      isGroupTransfer = response.Response.Data.GroupTransfer === true;
      this.postCallTimeout = response.Response.Data.PostCallTimeOut;

      this.queueServices.setCallID(response.Response.Data.CallSid);
      // console.log('setcurrentaction Callid:' + response.Response.Data.CallSid);
      this.queueServices.setEnterRecordTime(this.convertServerDate(response.Response.Data.EnterRecord));
      this.setEnterRecord(response?.Response?.Data?.EnterRecord);
      this.phoneNumber = response.Response.Data.PhoneNumber;
      this.enableDialManuallyButton = response.Response.Data.EnableDialManuallyButton;
      this.CalleeeUserID = response.Response.Data.UserID;
      this.isPostcalltranscription = response.Response.Data?.EnablePostCallTranscript;
      this.appService.setEnableTemplateButton(false);
      //Reset Transcript datas.
      this.TranscriptReset();
      this.transcriptService.SetAsPostCallTranscript(this.isPostcalltranscription);
     
      this.inbound = response.Response.Data.Inbound;
      //this.queueServices.setEnterRecordTime(this.convertServerDate(response.Response.Data.EnterRecord));
      //finally, update the data
      this.updateData(queueId, resumeInteraction, resumeInteraction);
     

      if (autoCall && !redial && !resumeInteraction) {
        this.callInProgress = true;
        this.callStarted_main({
          number: this.numberCalled,
          contact:
            typeof this.userDetailsData != 'undefined' &&
              this.userDetailsData != null &&
              this.userDetailsData.hasOwnProperty('FullName')
              ? this.userDetailsData.FullName
              : null,
          inbound: this.inbound,
          pendingTransfer: isGroupTransfer && !groupTransferComplete,
          interactionType: this.interactionType,
        });
        this.callEnded = false;
        // callFailureController.hide();
        //cls.view().callStarted(cls.cl().main().mainController().softPhone());
        this.callStarted_dialogctrl(this.softPhonefun());
        this.callConnected_dialog(null, null);
        this.checkCallStatus(false, false);
        if (isGroupTransfer) this.checkGroupTransferStatus();
      } else if (resumeInteraction) {
        // loadUserInfo();
      }
      
      this.isSetActionItemCompleted = true;
    });
  }

  IsGroupTransferCall() {
    return isGroupTransfer;
  }

  updateToSalesforce(response, interactionType) {
    if (interactionType == 'Blended' || interactionType == 'Inbound' || interactionType == 'Outbound' || interactionType == 'Search' || interactionType == 'Keypad') {
      const baseURL = { value: this.configService.geturl(Utils.fetch('clientAbbreviation')) };
      if (baseURL.value) {
        let crmUserID = response?.Response?.Data?.CrmUserID;
        let crmCaseID = response?.Response?.Data?.CrmCaseID;

        if (crmUserID) {
          this.navigateToSalesForcePage(baseURL, crmUserID, crmCaseID);
        }
        else if (response?.Response?.Data?.UserID) {
          this.queueServices.getUserDetails(response?.Response?.Data?.CaseID, response?.Response?.Data?.UserID).subscribe(userResponse => {
            crmUserID = userResponse?.Response?.Data?.CrmUserID;
            crmCaseID = userResponse?.Response?.Data?.CrmCaseID;
            this.navigateToSalesForcePage(baseURL, crmUserID, crmCaseID)
          });
        }
      }
    }
  }
  showAutomationWarning = function () {
    this.appService.setUserStatus(18, this.selectedQueueId);

    this.confirmDialogComponent
      .confirmdialog(
        '',
        'This is an automated queue.  If you choose to continue, a call will be placed immediately.  Are you ready to continue?',
        'Continue',
        'Cancel'
      )
      .then(confirmed => {
        if (confirmed) {
          this.userHasBeenWarned = true;
          this.waitForCall(this.queueServices.getselectedQueueId());
        } else {
          this.userHasBeenWarned = true;
          this.tmQueueService.setisBlendedQueue(false);
          this.tmQueueService.setshowdialerstatusmenu({ showstatusmenu: true });
        }
      })
      .catch(() =>
        console.log(
          'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
        )
      );
  };

  UserHasBeenWarned = function () {
    return this.userHasBeenWarned;
  };
  hideCallPrompt_fun() {
    this.hideCallPrompt = false;
    this.keypadCallPrompt = false;
    this.enableDialManuallyButton = false;
  }
  reset_dialogview() {
    this.hideCallPrompt = !this.keypadMode; //&& !hideAll
    this.keypadCallPrompt = this.keypadMode; //&& !hideAll
    this.IsCallPromptReadOnly = false;
    this.disableCallPromptControls = false; 
  }
  reset_phoneview() { 
    if (!this.callActive && !this.softPhoneActive) {    
      this.callEnded_view(true, false);      
    }
  }
  getCallPromptStatus() {
    return this.hideCallPrompt;
  }
  getkeypadCallPromptStatus() {
    return this.keypadCallPrompt;
  }
  getCallPromptReadOnlyStatus() {
    return this.IsCallPromptReadOnly;
  }
  keypadCallPrompt_callStarted = function () {
    // this.numberInput.enabled(false);
    //  callButton.enabled(false);
    this.disableCallPromptControls = true;
  };
  callConnected_dialog = function (phoneNumberType, saveToUserRecord) {
    this.callIsConnected = true;
    //cls.HangUpOnAttended(false);
    //cls.view().hideCallPrompt();
    this.hideCallPrompt_fun();
    //cls.view().startCallTimer();
    this.callConnected_phnctrl({
      number: this.numberCalled,
      contact:
        typeof this.userDetailsData != 'undefined' &&
          this.userDetailsData != null &&
          this.userDetailsData.hasOwnProperty('FullName')
          ? this.userDetailsData.FullName
          : null,
      inbound: this.inbound,
    });
    if (this.inbound && !this.conference && !this.transfer) {
      // loadUserInfo();
      //  reloadCallHistoryTab(userID); // ONV-535
    }
  };

  callConnected_phnctrl = function (data) {   
    this.callConnected_phnview(true);
    
  };

  callConnected_phnview = function (value) {
    console.log('callConnected_phnview called');
    if (this.PhoneEnabled() && value === true && !this.callEnded) {
      if (!this.isInternalTransfer) {
        // var status = { label: 'On Call', value: 5 };
        this.appService.setUserStatus(5, this.queueServices.getselectedQueueId());
      }
      
      this.callConnected = true;
      isCallConnected = true;
     
      this.startVideoRecording();
      this.startCallDurationTimer();

      let data: any = {};
      data = this.enableActiveCallButtons(
        !this.pendingTransferComplete,
        false,
        !this.pendingTransferComplete && this.holdBtnEnabled,
        this.queueServices.getisTransferViewActive(),
        false
      );
      
    }
    
  };

  startVideoRecording(): void 
  {
    try {
      if (this.WindowsWrapper?.IsWrapper()) 
      {
        const isRecordingAlive = this.queueServices?.getRecordingStatus() ?? false;
        if (!isRecordingAlive) 
        {
          this.WindowsWrapper?.StartVideoRecording();
          this.queueServices?.setRecordingStatus(true);
        }
      }
    } 
    catch (error: any) 
    {
      console.error(`Error while starting video recording: ${error?.message || error}`, error);
      this.queueServices?.setRecordingStatus(false);
    }
  }

  saveVideoRecording(id: any): void 
  {
    try {
      if (this.WindowsWrapper?.IsWrapper()) 
      {
          this.WindowsWrapper?.SaveVideoRecording(id);
          this.queueServices?.setRecordingStatus(false);
      }
    } 
    catch (error: any) 
    {
      console.error(`Error while saving video recording: interactionID ${id}, error: ${error?.message || error}`, error);
      this.queueServices?.setRecordingStatus(false);
    }
  }

  stopVideoRecording(): void 
  {
    try {
      if (this.WindowsWrapper?.IsWrapper()) 
      {
        this.WindowsWrapper?.StopVideoRecording();
        this.queueServices?.setRecordingStatus(false);
      }
    } 
    catch (error: any) 
    {
      console.error(`Error while stopping video recording: error: ${error?.message || error}`, error);
      this.queueServices?.setRecordingStatus(false);
    }
  }


  checkCallStatus_phnctrl(force, callback) {
    //console.log('checkcallstatus called:callended value:', this.callEnded)
    if (!this.callEnded)
      this.checkCallStatusTimeout1 = setTimeout(
        function () {
          var callID = '';
          if (this.dialerService.getIsFreeDialer()) {
            callID = this.queueServices.getChildCallID();
          }
          else {
            callID = this.queueServices.getCallID();
          }

          this.tmQueueService
            .getUpdate(callID, this.queueServices.getGroupTransferInteractionID())
            .subscribe(
              (response: any) => {
                this.updateCallStatus_phnctrl_timeout(response.Response.Data);
              },
              function (errorCode, message) { }
            );
        }.bind(this),
        force ? 0 : 1000
      );
  }

  updateCallStatus_phnctrl_timeout = function (data) {
  
    this.updateCallers(data.Callers);
    this.interactionID = data.InteractionID;
    
    if (data.InternalCallStatus == 'completed' || data.InternalCallStatus == 'busy') {
      this.tmQueueService.setCallTransfer_internalCallEnded({
        InternalCallStatus: data.InternalCallStatus,
        value: true,
      });
    } else if (data.InternalCallStatus == 'in-progress') {
      // cls.cl().main().mainController().transferController().internalCallInProgress(null, data.TransferRecipient.CallerName);
      var userIndex = this.getArrayIndex(data.Callers, 'User', 'UserType');
      var transferCaller = null;
      var transferAgent = null;
      if (userIndex != -1) {
        var user = data.Callers[userIndex];
        var phoneNumber = user.PhoneNumber;
        if (user.CallerName != 'User') transferCaller = user.CallerName;
        transferCaller =
          transferCaller == null
            ? phoneNumber == null
              ? 'Caller'
              : this.formatPhoneNumber(phoneNumber, '')
            : transferCaller;
      }
      if (data.TransferRecipient != null) {
        transferAgent = data.TransferRecipient.CallerName;
      }
      //this.transferWindowComponent.CallTransfer_internalCallInProgress.emit({ caller: transferCaller, agent: data.TransferRecipient.CallerName });
      // cls.cl().main().mainController().transferController().internalCallInProgress(transferCaller, transferAgent);
      this.tmQueueService.setCallTransfer_internalCallInProgress({
        caller: transferCaller,
        agent: data.TransferRecipient.CallerName,
        value: true,
      });
    }
    switch (data.Status) {
      case 2:
        //if(callInProgress)
        status = this.resolveCallStatus_phnctrl(data);
        break;
       
    }
  };

  resolveCallStatus_phnctrl = function (data) {
    //   console.log('resolve call status phone controller');
    
    (this.parentCallStatus = data.ParentCallStatus), (this.outgoingCallStatus = data.OutgoingCallStatus);
    if (this.parentCallStatus == 'completed' && this.outgoingCallStatus != 'failed') {
       
      this.callEnded_phnctrl(false, false, false);
    } else {
      // cls.callStatus((inbound || isGroupTransfer) ? parentCallStatus : outgoingCallStatus, inbound || isGroupTransfer, isSoftPhone, data.Message);
      this.callStatus_phnctrl(
        this.inbound || isGroupTransfer_phnctrl ? this.parentCallStatus : this.outgoingCallStatus,
        this.inbound || isGroupTransfer_phnctrl,
        this.isSoftPhone,
        data
      );
    }
    this.checkCallStatus_phnctrl(false, false);
  };

  // setTimeout(this.checkCallConnected.bind(this), 3000);
  checkCallStatus(force, callback) {
    //console.log('checkcallstatus called:callended value:', this.callEnded)
    if (!this.callEnded)
      this.checkCallStatusTimeout2 = setTimeout(
        function () {
          this.checkCallStatus_timeout(force, callback);
        }.bind(this),
        force ? 0 : 1000
      );
  }

  checkCallStatus_timeout = function (force, callback) {
    // console.log('checkCallStatus_timeout called:callended value:', this.callEnded)
    if (force === true || !this.callEnded)
      // a5.cl.plugins.InactivityLogout.instance().resetTimer();
      var callID = '';
    if (this.dialerService.getIsFreeDialer()) {
      callID = this.queueServices.getChildCallID();
    }
    else {
      callID = this.queueServices.getCallID();
    }
    //console.log('calling getupdate', callID)
    this.tmQueueService
      .getUpdate(callID, this.queueServices.getGroupTransferInteractionID())
      .subscribe(
        (response: any) => {
          this.statusFailures = 0;
          if (this.callIsConnected && response.Response.Data.OutgoingCallStatus == 'in-progress')
            groupTransferComplete = true;
          if (response.Response.Data.Callers != null && response.Response.Data.Callers.length > 0) {
            if (response.Response.Data.Callers[0].OnHold == false) {
              //&& cls.cl().main().mainController().transferController().isTransferCompleteProcessing()) {
              //cls.view().stopHoldTimer();
              //cls.view().stopHoldTimer()
              //cls.cl().main().mainController().phoneController().toggleHoldUI(true);
            }
          }
          this.updateCallStatus(response.Response.Data, force);
          if (typeof callback == 'function') callback.call();
        },
        function (errorCode, message) {
          this.statusFailures++;
          if (this.statusFailures == this.disconnectTimeout) {
            if (this.interactionType == 'InboundVideoChat' || this.interactionType == 'InboundTextChat') {
              // textChatView.chatEnded(im.CallStatus.COMPLETED, im.CallStatus.FAILED);
            }
            //cls.callCompleted();
          } else if (this.statusFailures < this.disconnectTimeout) {
            this.checkCallStatus(force, callback);
          }
        }
      );
  };

  updateCallStatus = function (data, forceCheckOutgoingStatus) {
    //console.log('updateCallStatus called, callInProgress:' + this.callInProgress);
    // cls.cl().main().mainController().updateCallParams(data.Params);
    this.interactionID = data.InteractionID;
    if (data.InteractionID && !this.dialerService.getIsFreeDialer()) {
      this.queueServices.setInteractionID(data.InteractionID);
    }
    this.queueServices.currentInteractionID(this.interactionID);
    //var rs = im.ResponseStatus,
    //    status = null,
    //    dialerError = 'Unexpected error (201).  Please refresh and try again.';
    if (data.InternalCallStatus == 'completed' || data.InternalCallStatus == 'busy') {
      //  cls.cl().main().mainController().transferController().internalCallEnded(data.InternalCallStatus);
      // this.transferWindowComponent.CallTransfer_internalCallEnded.emit({ InternalCallStatus: data.InternalCallStatus });
      this.tmQueueService.setCallTransfer_internalCallEnded({
        InternalCallStatus: data.InternalCallStatus,
        value: true,
      });
    } else if (data.InternalCallStatus == 'in-progress') {
      var userIndex = this.getArrayIndex(data.Callers, 'User', 'UserType');
      var transferCaller = null;
      if (userIndex != -1) {
        var user = data.Callers[userIndex];
        var phoneNumber = user.PhoneNumber;
        if (user.CallerName != 'User') transferCaller = user.CallerName;
        transferCaller =
          transferCaller == null
            ? phoneNumber == null
              ? 'Caller'
              : this.formatPhoneNumber(phoneNumber, '')
            : transferCaller;
      }
      //  this.transferWindowComponent.CallTransfer_internalCallInProgress.emit({ caller: transferCaller, agent: data.TransferRecipient.CallerName });
      // cls.cl().main().mainController().transferController().internalCallInProgress(null, data.TransferRecipient.CallerName);
      this.tmQueueService.setCallTransfer_internalCallInProgress({
        caller: transferCaller,
        agent: data.TransferRecipient.CallerName,
        value: true,
      });
    }

    if (this.callInProgress) {
      this.callers = data.Callers;
    
      this.updateCallers(this.callers);
    }
    if (forceCheckOutgoingStatus === true) {
      
    } 
    switch (data.Status) {
      case 2:
        //if(callInProgress)
        status = this.resolveCallStatus(data);
        break;
      
    }
    //}
  };
  resolveCallStatus = function (data) {
    
    (this.parentCallStatus = data.ParentCallStatus), (this.outgoingCallStatus = data.OutgoingCallStatus);
    if (this.parentCallStatus == 'completed' && this.outgoingCallStatus != 'failed') {
     
      if (!this.callEnded) {
        this.callCompleted();
      }
       
    }
     
    else {
      this.callStatus_phnctrl(
        this.inbound || isGroupTransfer ? this.parentCallStatus : this.outgoingCallStatus,
        this.inbound || isGroupTransfer,
        this.isSoftPhone,
        data
      );
      //cls.dispatchEvent(im.CallEvent.STATUS_UPDATE, { callStatus: (inbound || !outgoingCallStatus) ? parentCallStatus : outgoingCallStatus, inbound: inbound || !outgoingCallStatus, isSoftPhone: isSoftPhone, message: data.Message });
      if (this.inbound || !this.outgoingCallStatus) {
        var failed = false;
        switch (this.parentCallStatus) {
          case 'queued':
          case 'ringing':
          case 'in-progress':
          default:
            //cls.view().updateCallStatus(isSoftPhone ? 'starting the call...' : 'calling your phone...');
            if (this.inbound && this.parentCallStatus != 'in-progress') {
              //dialogStatus.text('Dialing your phone.  Please wait...');
              //dialogStatusHolder.visible(true);
            } else if (this.inbound && this.parentCallStatus == 'in-progress') {
              //dialogStatusHolder.visible(false);
              // If the user call failed when being routed into the conference
              if (this.outgoingCallStatus == 'failed') {
                //displayFailure("We were unable to connect the call to you.\nPress OK to return to the queue.");
                this.callInProgress = false;
                failed = true;
              } else if (!this.callIsConnected && this.callInProgress) {
                //callConnected();
              }
            }
            if (this.interactionType == 'InboundVideoChat' || this.interactionType == 'InboundTextChat') {
              // dialogStatusHolder.visible(false);
            }
            if (this.outgoingCallStatus == 'completed') {
              // cls.cl().main().mainController().transferController().callerHungUp();
              //  this.transferWindowComponent.CallTransfer_callerHungUp.emit();
              this.tmQueueService.setCallTransfer_callerHungUp({ value: true });
            }
            break;
          case 'failed':
            //displayFailure(isSoftPhone ? "Softphone error (104).  Please refresh and try again." : "Unable to call your phone.  Please try again, or bypass the dialer if the problem persists.");
            //callInProgress = false;
            //failed = true;
            break;
          case 'completed':
          case 'no-answer':
            //displayFailure(isSoftPhone ? "Softphone error (101).  Please refresh and try again." : "You didn't pick up.");
            //callInProgress = false;
            //failed = true;
            break;
          case 'machinePickup':
            //displayFailure("We got your voicemail.");
            //callInProgress = false;
            //failed = true;
            break;
          case 'busy':
            //displayFailure(isSoftPhone ? "Softphone error (102).  Please refresh and try again." : "Your phone is busy.");
            //callInProgress = false;
            //failed = true;
            break;
        }
        //if (inbound && failed) {
        //    dialogStatusHolder.visible(false);
        //    im.UIAlert.open('We were unable to connect the call to you. ' + (isSoftPhone ? '' : 'Please confirm that your phone number is correct. ') + 'Press OK to return to the queue.', function () {
        //        window.location.replace(window.location.protocol + "//" + window.location.host);
        //    });
        //} else if (failed)
        //    return;
      } else {
        switch (this.outgoingCallStatus) {
          case 'queued':
          case 'ringing':
          default:
            if (!this.callEnded) {
              // cls.view().updateCallStatus('dialing...');
            }
            break;
          case 'in-progress':
            if (!this.callIsConnected && this.callInProgress) {
              //callConnected(phoneNumberType, saveToUserRecord);
              this.callConnected_dialog(null, null);
            }
            break;
          case 'completed':
                if (!this.onHold && !this.callEnded && (this.parentCallStatus != 'in-progress' && data.InternalCallStatus != 'in-progress')) {

                    //  this.callCompleted();
                    const apiCallId = data?.CallId?.trim();
                    // console.log('getupdate-> apiCallId:', apiCallId);
                    if (apiCallId) {

                        const currentCallId = this.dialerService.getIsFreeDialer()
                            ? this.queueServices.getChildCallID()
                            : this.queueServices.getCallID();
                        // console.log('getupdate-> currentCallId:', currentCallId);
                        if (currentCallId && apiCallId === currentCallId) {
                            console.log(
                                'getUpdate -> Call IDs match. Executing callCompleted().', 'Current CallId:', currentCallId, 'API CallId:', apiCallId
                            );

                            this.callCompleted();
                        } else {
                            console.log(
                                'getUpdate -> Call IDs do not match. callCompleted() will not be executed.', 'Current CallId:', currentCallId, 'API CallId:', apiCallId
                            );
                        }
                    }

                }
            this.tmQueueService.setCallTransfer_callerHungUp({ value: true });
            return;
          //case cs.MACHINE_PICKUP:
          //    callInProgress = false;
          //    displayFailure(outgoingCallStatus, true, 'Left Voicemail');
          case 'failed':
            this.callInProgress = false;
            switch (data.Message) {
              case '13227': //No International Authorization
                // displayFailure("Cannot dial international numbers.  Please dial manually.");
                break;
              default:
                // displayFailure(outgoingCallStatus, true, 'Wrong/Bad Number');
                this.showValidationError('Wrong/Bad Number', true, 'block', false);
            }
            return;
          case 'no-answer':
            this.callInProgress = false;
            this.showValidationError('No Answer', true, 'block', false);
            // displayFailure(outgoingCallStatus, true, 'No Answer');
            // cls.callCompleted();
            return;
          case 'busy':
            this.callInProgress = false;
            this.showValidationError('Line Busy', true, 'block', false);
            // displayFailure(outgoingCallStatus, true, 'Line Busy');
            return;
        }
      }
    }
    // console.log('resolvecallstatus called');
    this.checkCallStatus(false, false);
  };
  callStatus_phnctrl = function (callStatus, inbound, isSoftPhone, data) {
    /* var cs = im.CallStatus;*/
    var status = 'Ready';
    //var currStatus = cls.view().callStatus();
    //var callActive = cls.view().isCallActive();
    //var callConnected = cls.view().callConnected();

    if (this.inbound) {
      switch (callStatus) {
        case 'queued':
        default:
          status = this.isSoftPhone ? 'Initializing...' : 'Dialing Your Phone';
          break;
        case 'ringing':
          status = this.isSoftPhone ? 'Connecting...' : 'Ringing Your Phone';
          break;
        case 'in-progress':
          status = this.callActive
            ? this.currStatus == 'On Call' || this.currStatus == 'Starting Call'
              ? 'On Call'
              : 'Starting Call'
            : this.isSoftPhone
              ? 'Connecting'
              : 'Ringing Your Phone';
          if (this.callActive && !this.callConnected) this.callConnected_phnview(true);
          break;
        case 'failed':
          //cls.view().callEnded();
          //if (cls.cl().main().mainController().activeController() == "ExternalSystem") {
          //    cls.unableToRouteUserCall(true);
          //} else {
          //    cls.view().showError(true, (isSoftPhone) ? "Softphone error (104). Please refresh and try again." : "Unable to call your phone. Please try again, or bypass the dialer if the problem persists.");
          //}
          break;
        case 'completed':
        case 'no-answer':
          // cls.view().callEnded();
          this.callEnded_view(false, false);
          //if (interactionType != 'InboundVideoChat' && interactionType != 'InboundTextChat')
          //    cls.view().showError(true, (isSoftPhone) ? "Softphone error (101).  Please refresh and try again." : "You didn't pick up.");
          break;
        //case cs.MACHINE_PICKUP:
        //    cls.view().callEnded();
        //    cls.view().showError(true, "We got your voicemail.");
        //    break;
        case 'busy':
          //cls.view().callEnded();
          this.callEnded_view(false, false);
          //cls.view().showError(true, (isSoftPhone) ? "Softphone error (102).  Please refresh and try again." : "Your phone is busy.");
          break;
      }
    } else {
      switch (callStatus) {
        case 'queued':
        default:
          status = this.isSoftPhone ? 'Initializing...' : 'Dialing Your Phone';
          break;
        case 'ringing':
          status = this.isSoftPhone ? 'Connecting...' : 'Ringing Your Phone';
          break;
        case 'in-progress':
          status = this.callActive
            ? this.currStatus == 'On Call' || this.currStatus == 'Starting Call'
              ? 'On Call'
              : 'Starting Call'
            : this.isSoftPhone
              ? 'Connecting'
              : 'Ringing Your Phone';
          if (this.callActive && !this.callConnected) {
            if (data?.Callers[0].CallID) {
              if (this.dialerService.getIsFreeDialer()) {//8->post call
                this.queueServices.setChildCallID(data.Callers[0].CallID);
                console.log('dialer component set child id', data.Callers[0].CallID);

              }
              else {
                this.queueServices.setCallID(data.Callers[0].CallID);
                console.log('dialer component set parent id', data.Callers[0].CallID);
              }
            }

            //console.log('Outbound status set CALLID:' + this.queueServices.getCallID());
            this.dialerService.setCallConnected(true);
            this.callConnected_phnview(true);
          }
          break;
        case 'failed':
          //cls.view().callEnded();
          //if (cls.cl().main().mainController().activeController() == "ExternalSystem") {
          //    cls.unableToRouteUserCall(true);
          //} else {
          //    cls.view().showError(true, (isSoftPhone) ? "Softphone error (104). Please refresh and try again." : "Unable to call your phone. Please try again, or bypass the dialer if the problem persists.");
          //}
          this.callEnded_view(false, false);
          this.showValidationError(
            this.isSoftPhone
              ? 'Softphone error (104). Please refresh and try again.'
              : 'Unable to call your phone. Please try again, or bypass the dialer if the problem persists.',
            true,
            'block', false
          );
          return;
        case 'completed':
          //cls.view().callerHungUp();
          //cls.cl().main().mainController().transferController().callerHungUp();
          return;
        case 'no-answer':
          // console.log('no-answer case');
          this.callEnded_view(false, false);
          //cls.view().showError(true, "No Answer", null, true);
          this.showValidationError('No Answer', true, 'block', false);
          return;
        //case cs.MACHINE_PICKUP:
        //    status = 'Voicemail';
        //    return;
        case 'busy':
          //cls.view().callEnded();
          this.callEnded_view(false, false);
          this.showValidationError('Line Busy', true, 'block', false);
          // cls.view().showError(true, "Line Busy", null, true);
          return;
      }
    }
    //cls.view().callStatus(status);
  };

  updateCallers = function (value) {
    // console.log('updateCallers triggered, callActive:' + this.callActive + ',callConnected: ' + this.callConnected);
    if (!this.phoneEnabled || typeof value == 'undefined' || value == null) return this.callers;
    this.callers = value;
    this.queueServices.setactivecallers(value);
    var dialerStatusText = '';
    if (this.callActive && this.callConnected) {
      var userIndex = this.getArrayIndex(this.callers, 'User', 'UserType');
      var agentIndex = this.getArrayIndex(this.callers, 'Agent', 'UserType');
      var managerIndex = this.getArrayIndex(this.callers, 'Manager', 'UserType');
      var thirdPartyIndex = this.getArrayIndex(this.callers, 'ThirdParty', 'UserType');
      if (userIndex != -1) {
        var user = this.callers[userIndex];
        this.holdBtnEnabled = true;
        this.phoneNumber = user.PhoneNumber;
        if (user.CallerName != 'User') this.contactName = user.CallerName;
        dialerStatusText =
          (this.inbound ? 'Inbound: ' : 'Outbound: ') +
          (this.contactName == null || this.contactName == ' '
            ? this.phoneNumber == null || this.interactionName == 'Chat'
              ? this.interactionName + ' Connected'
              : this.formatPhoneNumber(this.phoneNumber)
            : this.contactName);
        //dialerStatusText.tooltip(dialerStatusText.text());
      } else if (agentIndex != -1 && this.pendingTransferComplete) {
        dialerStatusText = 'Transfer: ' + this.callers[agentIndex].CallerName;
        //dialerStatusText.tooltip(dialerStatusText.text());
      }
      // Remove managers from caller list
      if (managerIndex != -1) {
        var newCallers = new Array();
        for (var i in this.callers) {
          if (this.callers[i].UserType != 'Manager') newCallers.push(this.callers[i]);
        }
        this.callers = newCallers;
      }
      if (((userIndex == -1 && thirdPartyIndex != -1) || (userIndex == -1 && agentIndex != -1)) && dialerStatusText == '') {
            dialerStatusText = 'Customer has ended the call';
      }
      let data: any = {};

      data = this.enableActiveCallButtons(
        !this.pendingTransferComplete,
        this.callers.length > 1,
        !this.pendingTransferComplete && this.holdBtnEnabled,
        this.queueServices.getisTransferViewActive()
      );
      data.dialerStatusText = dialerStatusText;
      this.redrawDialerPanel(data);
      //if (conferenceOpen) {
      //    if (callers.length > 1)
      //        populateConferenceList(callers);
      //    else
      //        this.showConference(false);
      //}
    }
  };

  getArrayIndex = function (array, search, propName) {
    for (var i = 0; i < array.length; i++) {
      if (propName != null) {
        if (array[i][propName] == search) {
          return i;
        }
      } else if (array[i] == search) {
        return i;
      }
    }
    return -1;
  };
  resetCallStatuses = function () {
    this.parentCallStatus = null;
    this.outgoingCallStatus = null;
    this.statusFailures = 0;
  };

  eCallEndedHandler = function () {
    //if (spokesClient)
    //    spokesClient.endCall();
    //$('#holdBtn').css('display', 'none');
    if (!this.softPhone) {
      // $('#hangUpBtn, #holdBtn').css('display', 'none');
      phoneController.callEnded();
    }
  };

  softPhonefun = function () {
    return this.softPhone;
  };
  automatedfun = function (value, _predictive, keypad) {
    //if (typeof value == "undefined")
    //    return automated;
    this.automated = !!value;
    this.predictive = !!_predictive;
    this.keypadMode = !!keypad;
    this.backBtn = (!this.automated || !this.predictive) && !this.keypadMode;
    
  };

  updateData(id, bypassCallPrompt, callCompleted) {
    
    ////reset
    console.log('calltransfer issue->updatedata rchd');
    this.autoAdvanceEnabled = true;
    //postCallTimeoutAlert.visible(false);
    this.postCallTimeoutAlert = false;
    clearInterval(this.postCallTimeoutInterval);
    //this.dialerType = this.dialerType ?? this.queueDialerType;
    if (
      this.queueDialerType == 'Preview' ||
      this.queueDialerType == 'Power' ||
      this.queueDialerType == 'Progressive' ||
      this.queueDialerType == 'Predictive' ||
      this.queueDialerType == 'AutomatedInbound' ||
      this.queueDialerType == 'Keypad'
    ) {
      this.automatedfun(
        true,
        this.queueDialerType == 'Progressive' ||
        this.queueDialerType == 'Predictive' ||
        this.queueDialerType == 'AutomatedInbound',
        this.queueDialerType == 'Keypad'
      );
    } else {
      this.automatedfun(false, false, false);
    }
    //cls.view().reset(false, bypassCallPrompt);
    this.reset_dialogview();
     
    this.callEnded = !!callCompleted;
    if (this.callCompleted) {
      //cls.view().callCompleted();
    }

    //hide the groups tab for not Inbound queue
    if (this.inbound) {
      if (!callCompleted) {
        this.callInProgress = true;
        //callFailureController.hide();
        this.callStarted_main({
          number: this.numberCalled,
          contact:
            typeof this.userDetailsData != 'undefined' &&
              this.userDetailsData != null &&
              this.userDetailsData.hasOwnProperty('FullName')
              ? this.userDetailsData.FullName
              : null,
          inbound: this.inbound,
          interactionType: this.interactionType,
        });
        // cls.view().callStarted(cls.cl().main().mainController().softPhone());
        this.callStarted_dialogview(true); //hardcoded true now
      }
      console.log('calltransfer issue->updatedata rchd2');
      if (this.conference) {
         
      } else if (!autoCall) {
        if (this.interactionType == 'InboundVideoChat' || this.interactionType == 'InboundTextChat') {
          //  chatService.AnswerInboundChat({ chatID: callSid }, successCallback, errorCallback);
        } else {
          console.log('calltransfer issue->updatedata rchd3');
          //interactionService.AnswerInboundCall({ callID: callSid }, successCallback, errorCallback);
          setTimeout(
            function () {
              this.tmQueueService
                .answerInboundCall(this.queueServices.getCallID(), this.queueServices.getselectedQueueId())
                .subscribe(data => {
                  console.log('calltransfer issue->updatedata rchd4,callid:', data.Response.Data?.CallID);
                  // this.answerInboundCall_successCallback(data.Response.Data), this.answerInboundCall_errorCallback(data.Response.Data)
                  if (data.Response.Data?.CallID) {
                    this.answerInboundCall_successCallback(data.Response.Data);
                  } else if (data.Response?.Message) {
                    this.answerInboundCall_errorCallback(data.Response);
                  }
                });
            }.bind(this),
            1000
          );
        }
      }
    } 
  }

  answerInboundCall_successCallback = function (response) {
    console.log('answerInboundCall response', response);
    this.dialerService.setPhoneNo(response.PhoneNumber);
    if (this.queueServices.getCallID() == null && response.CallID != '' && response.CallID != null)
      this.queueServices.setCallID(response.CallID);
     
    this.setAnswerInboundCalldata(response);
     
    if (response.DialerResponse) this.updateCallStatus(response.DialerResponse);
    else {
      // callConnected();
      this.checkCallStatus(false, false);
      this.transfer = true;
    }
     
  };

  setAnswerInboundCalldata(data: any) {
    console.log('setAnswerInboundCalldata');
    this.appService.setUserStatus(5, this.queueServices.getselectedQueueId());
    this.appService.setActionItemId(this.queueServices.getselectedQueueId() + '-' + data.UserID + '-' + data.CaseID);
    this.setCurrentCallee(data.UserID);
    this.queueServices.SetDisableHeader(true);
    this.queueServices.setCaseDetailsLoaded(true);
    if (data.UserID) { this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/caseDetails']); this.setSearchUserSelected(true); }
    else {
      this.appService.setActionItemId(this.queueServices.getselectedQueueId() + '-' + null + '-' + null);
      this.RedirectToCaseDetailFromcallTransfer(data);
    }
  }
  answerInboundCall_errorCallback = function (Response) {
    
    var automated =
      this.queueDialerType == 'Preview' ||
      this.queueDialerType == 'Power' ||
      this.queueDialerType == 'Progressive' ||
      this.queueDialerType == 'Predictive' ||
      this.queueDialerType == 'AutomatedInbound' ||
      this.queueDialerType == 'Keypad';
    //alert.open("<p>" + message + "</p><p>Press OK to " + (automated ? "go to the next record." : "return to the queue.") + "</p>", function () {
    //    goToNextCall();
    //});
    this.setAllDialerWindowStatus(false, false, false);
    var msg = Response.Message + ' Press OK to ' + (automated ? 'go to the next record.' : 'reload the queue.');
    this.confirmDialogComponent
      .confirmdialog('', msg, 'OK', '')
      .then(confirmed => {
        if (confirmed) {
          this.queueServices.setTaskMenuQueueSelected({
            pageRefresh: true,
            isPageInitCompleted: false,
            queueType: 'Inbound',
          });
          this.queueServices.setIsPageLoadCompleted(false);
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/Inbound'], {
              queryParams: { qid: this.queueServices.getselectedQueueId() },
            });
          });
        }
      })
      .catch(() =>
        console.log(
          'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
        )
      );
  };
  Showdialer(isPartialTransfer: boolean, forceShowDialer: boolean = true) {
    if (forceShowDialer) {
      if (isPartialTransfer) {
        this.dialerService.setDeviceReady(false);
        this.dialerService.setConnections(false);
        // this.dialerService.setWaitingForInboundCall(false);
        this.dialerService.setShowDialer(true);
        this.dialerService.setCallConnected(true); // Show timer
      } else {
        this.dialerService.setDeviceReady(false);
        this.dialerService.setConnections(false);
        // this.dialerService.setWaitingForInboundCall(false);
        this.dialerService.setShowDialer(true);
        this.dialerService.setCallConnected(true); // Show timer
        this.appService.setUserStatus(5, this.selectedQueueId);
        this.queueServices.SetDisableHeader(true);
        this.queueServices.setCaseDetails_ENABLECONTROLS(true);
        if (!this.queueServices.getLoadCaseCaseDetails()) {
          clearInterval(this.actionItemCheckStatusInterval);
          this.actionItemCheckStatusInterval = setInterval(() => {
            if (this.isSetActionItemCompleted) {
              clearInterval(this.actionItemCheckStatusInterval);
              this.RedirectToCaseDetails();
            }
          }, 100);
        }
      }
    } else {
      this.dialerService.setDeviceReady(false);
      this.dialerService.setConnections(false);
      // this.dialerService.setWaitingForInboundCall(false);
      this.dialerService.setShowDialer(false);
      this.dialerService.setCallConnected(false); // Show timer
      //  this.appService.setUserStatus(5, this.selectedQueueId);
      this.queueServices.SetDisableHeader(true);
      this.queueServices.setCaseDetails_ENABLECONTROLS(true);
      if (!this.queueServices.getLoadCaseCaseDetails()) {
        clearInterval(this.actionItemCheckStatusInterval);
        this.actionItemCheckStatusInterval = setInterval(() => {
          if (this.isSetActionItemCompleted) {
            clearInterval(this.actionItemCheckStatusInterval);
            this.RedirectToCaseDetails();
          }
        }, 100);
      }
    }
  }
  softPhoneRegistered() {
    if (!this.softPhoneActive) this.appService.setSoftPhoneStatus('Ready');

    //closeSoftPhoneBlocker();
    if (softPhoneInitializing) {
      softPhoneInitializing = false;
      this.softPhoneInitialized();
      //if (messagePreviewing && softPhoneCallback != null)
      //    this.softPhoneCallback();
    }
  }
  softPhoneUnregistered = function (cause) {
    // cls.profileStatus().setSoftPhoneStatus('Disconnected');
    if (!softPhoneInitializing && cause) {
      
      this.confirmDialogComponent
        .confirmdialog('', 'The soft phone encountered an error: ' + cause + ' Click OK to reconnect.', 'OK', '')
        .then(confirmed => {
          if (confirmed) {
            if (this.useTwilioClient()) {
              this.loaderService.display(true);
              this.dialerService.setIsBlockLoader(true);
              //this.setPredictiveOpen(true);
              this.isSoftphoneErrorOccurred = true;
              //console.log('The soft phone encountered an error called and isSoftphoneErrorOccurred', this.isSoftphoneErrorOccurred);
              this.initializeSoftPhone();
              this.dialerService.setIsBlockLoader(false);
            } else {
              //sipUA.register();
            }
          }
        })
        .catch(() =>
          console.log(
            'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
          )
        );
    }
  };
  useTwilioClient() {
    return 'Twilio';
  }

  previewMessage(isPromptID, message, onConnect, onDisconnect) {
    var softPhoneChanged = !this.useTwilioClient();
    messagePreviewing = true;
    messagePreviewContent = message;
    messagePreviewClient = phoneClient;
    messagePreviewOnConnect = onConnect;
    messagePreviewOnDisconnect = onDisconnect;
    phoneClient = 'Twilio';
    var softPhoneCallbackfun = function () {
      var params = {
        //client: cls.QBRSecurity().clientShortName(),
        client: 'HR1',
        isPromptID: isPromptID,
        message: (message ?? '').trim(),
      };
      this.makePreviewCall(params);
       
    };
    //this.phoneNumberSetup(softPhoneChanged);
  }
  makePreviewCall(params) {
    
  }
  openSoftPhoneBlocker() {
    
  }
  softPhoneInitialized() {
    if (waitForCallPending) {
      waitForCallPending = false;
      this.waitForCall(null);
    }
  }

  waitForCall(_queueID) {
    // console.log('waitForCall called');
    //cls.profileStatus().setAgentStatus(6);
    //cls.lockStatus({ label: 'In Queue', value: 6 });
    if (softPhoneInitializing) waitForCallPending = true;
    else if (!this.ispredictiveOpen()) {
      if (this.softPhone && this.twilioVoice.hasActiveCall()) this.twilioVoice.hangup();
      //predictiveWaitBlocker.open(_queueID || queueID, automatedInbound, interactionType);
      //this.interactionType = "InboundCall";
      //this.predictiveWaitBlocker.open(_queueID || this.queueID, this.automatedInbound, this.interactionType);
      this.Predictiveopen(
        _queueID || this.queueServices.getselectedQueueId(),
        this.automatedInbound,
        this.interactionType
      );
    }
  } 
  softPhoneCallAccepted(sipMessage, callData) {
    console.log('softPhoneCallAccepted');
    //reset softphone failures
    this.softphoneFailures = 0;
    //update the UI
    // $('#keypadBtn, #muteBtn, #hangUpBtn').css('display', 'inline-block');

    // phoneController.softPhoneActive(true);
    this.softPhoneActive = true;
    this.setSoftPhoneActive(true);
    // cls.profileStatus().setSoftPhoneStatus('Active');

    this.appService.setSoftPhoneStatus('Active');
    if (callData) this.callStarted_main(callData);

    if (this.isListeningIn) {
      this.muteUnmuteMic(this.ListenInisMuted);
    }
    if (this.conferenceID && !this.automatedCall) {
      //    this.cachedStatus = this.curUserStatus;
      // cls.lockStatus({ label: 'On Call', value: 5 });
    } else if (
      (this.ispredictiveOpen() && this.Predictive_inbound) ||
      (this.ispredictiveOpen() && this.UserHasBeenWarned())
    ) {
      this.softPhoneConnected();
    } else if (sipMessage != null) {
      //softPhoneProcessMessage(sipMessage);
    }
    if (callData) {
      if (callData.isIgnore) this.endCall_main(false, false);
    }
  }
  softPhoneDisconnected = function (): void {
    if (this.ispredictiveOpen() && this.Predictive_inbound) {
      this.callID = null;
      this.setAllDialerWindowStatus(false, true, false);
      this.showPhoneMessaging('Connecting your softphone. Please wait...');
      this.updateStatusSet(false);
      this.isSoftphoneErrorOccurred = false;
      //console.log('softPhoneDisconnected called and isSoftphoneErrorOccurred', this.isSoftphoneErrorOccurred);
      this.dialerService.setConnections(true);
      // hideTimer();
      this.waitingForCall();
    }
  };
  softPhoneCallFailed = function (cause) {
    this.call = null;
    this.softphoneFailures++;
    //phoneController.callEnded();
    this.callEnded_phnctrl(false, false, false);
    //$('#keypadBtn, #muteBtn, #hangUpBtn').css('display', 'none');
    //if (keypad && keypad.isOpen()) keypad.close();
    if (this.ispredictiveOpen() && this.Predictive_inbound) {
      //predictiveWaitBlocker.isOpen()
      if (this.softphoneFailures < 5) this.softPhoneDisconnected();
      //im.UIAlert.open('Error answering the softphone.<br />Cause: ' + cause + '<br /><br />Press OK to reload Onvida.', function () {
      //    window.location.replace(window.location.protocol + "//" + window.location.host);
      //});
      else
        this.confirmDialogComponent
          .confirmdialog('', 'Error answering the softphone. Cause: ' + cause + ' Kindly reload Onvida.', 'OK', '')
          .then(confirmed => {
            if (confirmed) {
              // window.location.replace(window.location.protocol + "//" + window.location.host);
            }
          });
    } else {
      //softPhoneCallFailedAlert.open('Error answering the softphone.<br />Cause: ' + cause);
      this.confirmDialogComponent
        .confirmdialog('', 'Error answering the softphone. Cause: ' + cause, 'OK', '')
        .then(confirmed => {
          if (confirmed) {
          }
        });
      this.softPhoneFailed();
    }
  };
  softPhoneFailed = function () {
    this.callInProgress = false;
    //displayFailure('Softphone error (103).  Please check your headset connection, then refresh and try again.');
    this.confirmDialogComponent
      .confirmdialog(
        '',
        'Softphone error (103).  Please check your headset connection/Microphone access provided in browser, then refresh and try again.',
        'OK',
        ''
      )
      .then(confirmed => {
        if (confirmed) {
          this.setAllDialerWindowStatus(false, false, false);
        }
      });
  };
  callStarted_main = function (callData) {
    console.log('callStarted_main');
    if (callData.hasOwnProperty('interactionType')) this.interactionType = callData.interactionType;
    //if (newCallNotification)
    //    newCallNotification.close();
    this.enableControls(this.interactionType);
    this.callStarted_phnCtrl(callData);
  };
  enableControls(type) {
    this.queueServices.setCaseDetails_ENABLECONTROLS(true);
     
  }
  callStarted_phnCtrl = function (data) {
    console.log('callStarted_phnCtrl');
    if (this.PhoneEnabled()) {
      this.tmQueueService.setCallTransfer_Reset({ value: true });//resetting transfer window variables
      this.appService.setHasOpenedQNX(false);
      this.inbound = data.inbound === true;
      this.interactionType = data.hasOwnProperty('interactionType') ? data.interactionType : null;
      this.parentCallStatus = null;
      this.outgoingCallStatus = null;
      this.waitingForCallToComplete = false;
      this.callTransferred = false;
      this.transferCancelledBySender = false;
      // contactName = cls.view().contactName();
      this.callData = data;
      this.callData.checkStatus = data.hasOwnProperty('checkStatus') && data.checkStatus === true;
      //if (cls.cl().main().mainController().activeController() != "Dialog") {
      //    cls.videoRecordingStart();
      //}
      isGroupTransfer_phnctrl = data.hasOwnProperty('pendingTransfer') && data.pendingTransfer === true;
      groupTransferComplete_phnctrl = !isGroupTransfer_phnctrl;
      this.phoneNumber_view(this.callData.number, false, this.callData.contact);
      this.callStarted_view(data);
      console.log('is internal transfer:', data?.isInternalTransfer);
      if ((!this.inbound && this.isOutbound && !this.getisCaseDetailStatus() && !data?.isInternalTransfer) || this.callData.checkStatus) {/*should connect if status is inqueue only*/
        this.checkCallStatus_phnctrl();
        if (isGroupTransfer_phnctrl) {
          this.checkGroupTransferStatus();
        }
      }
    }

  };
  callStarted_view = function (callData) {
    console.log('callStarted_view called');
    let data: any = {};

    if (!this.selfInitiated) {
      this.callEnded = false;
    }
    if (!this.callEnded) {
      this.interactionType = callData.hasOwnProperty('interactionType') ? callData.interactionType : null;
      this.interactionName =
        this.interactionType == 'InboundTextChat' || this.interactionType == 'InboundVideoChat' ? 'Chat' : 'Call';
      //if (cls.cl().main().mainController().activeController() == "ExternalSystem")
      //    im.ExternalSystemController.instance().availableControlsEnabled(false);
      // updateViewPosition(phoneEnabled, externalSystem, externalSystemName);
      this.inbound = callData.inbound;
      this.isInternalTransfer = callData.isInternalTransfer === true;
      this.isInternalCallConnected = this.isInternalTransfer;
      if (!this.selfInitiated && !callData.isInternalTransfer) this.clearPhoneNumber();
      if (callData.isInternalTransfer) {
        //this.internalAddRecipientToggle(true);
        this.callConnected_view(true);
      }
      this.pendingTransferComplete = callData.pendingTransfer === true;
       
      this.callActive = true;
      this.holdBtnEnabled = true;
      this.isAttendedTransfer = false;
 
      data = this.enableActiveCallButtons(
        false,
        false,
        this.holdBtnEnabled,
        this.queueServices.getisTransferViewActive(),
        true
      );
      if (callData.isInternalTransfer) {
        data.dialerStatusText =
          (this.inbound ? 'Inbound: ' : !this.isInternalTransfer ? 'Outbound: ' : 'Internal Transfer: ') +
          (this.contactName == null || this.contactName == ' '
            ? this.phoneNumber == null || this.interactionName == 'Chat'
              ? this.interactionName + ' Connected'
              : this.phoneNumber
            : this.contactName);
      }
      this.dialerService.setResetTimer(true);
      //this.startCallDurationTimer();
      //this.dialerService.setResetTimer(true);
      this.redrawDialerPanel(data);
      //redraw();
    }
  };
  callStarted_dialogview = function (usingSoftPhone) { 
    this.keypadCallPrompt_callStarted(); 
  };
   
  enableActiveCallButtons = function (enabled, hasConfCallers, enabledHold, isTransferActive, resetbuttonstodefault) {
    let ActiveButtonsdata: any = {};
    enabledHold = enabledHold && this.dialerService.getCurrentTransferStep() != 2;
    this.isConferenceCall = hasConfCallers;
    if (this.softPhoneActive) {
      this.muteBtn_enabled =
        enabled && this.interactionType != 'InboundTextChat' && this.interactionType != 'InboundVideoChat';
      if (!this.isAttendedTransfer) {
        this.holdBtn_enabled = enabled && enabledHold && this.interactionType != 'InboundTextChat';
        this.transfersBtn_enabled =
          enabled &&
          enabledHold &&
          !this.isPersonalCall &&
          this.interactionType != 'InboundTextChat' &&
          this.interactionType != 'InboundVideoChat' &&
          !this.isAttendedTransfer;
      } else {
        this.transfersBtn_enabled = false;
        this.keypadBtn_enabled = false;
      }
    } else {
      this.muteBtn_enabled = false;
      if (this.interactionType == 'InboundTextChat' || this.interactionType == 'InboundVideoChat')
        this.holdBtn_enabled = false;
    }

    this.keypadBtn_enabled =
      enabled &&
      this.interactionType != 'InboundTextChat' &&
      this.interactionType != 'InboundVideoChat' &&
      !this.isAttendedTransfer;

    this.conferenceBtn_enabled = this.isConferenceCall && !this.isAttendedTransfer;
    if (this.isConferenceCall && isTransferActive) {
      this.hangUpBtn_enabled = false;
    } else { 
      this.hangUpBtn_enabled = !this.callEnded;
    }
 
    if (isTransferActive) {
      this.hangUpBtn_enabled = false; 
    }

    if (this.onHold) {
        this.hangUpBtn_enabled = false;
    }

    ActiveButtonsdata.muteBtn_enabled = this.muteBtn_enabled;
    ActiveButtonsdata.keypadBtn_enabled = this.keypadBtn_enabled;
    ActiveButtonsdata.holdBtn_enabled = this.holdBtn_enabled;
    ActiveButtonsdata.hangUpBtn_enabled = this.hangUpBtn_enabled;
    ActiveButtonsdata.transfersBtn_enabled = this.transfersBtn_enabled;
    ActiveButtonsdata.conferenceBtn_enabled = this.conferenceBtn_enabled;
    ActiveButtonsdata.resetbuttonstodefault = resetbuttonstodefault;

    return ActiveButtonsdata;
  };

  callConnected_view = function (value) {
    console.log('callConnected_view');
    if (this.phoneEnabled && value === true && !this.callEnded) {
      if (!this.isInternalTransfer) {
        var status = { label: 'On Call', value: 5 };
      }
      if (this.selfInitiated) {
        if (this.isAway) {
          if (this.isPersonalCall) {
            status = { label: 'Away - On Call', value: 16 };
          } else {
            status = { label: 'Away - On Call', value: 15 };
          }
        }
      }
      //cls.cl().main().mainController().lockStatus(status);
      this.callConnected = true;
      this.startCallDurationTimer();
      this.setenableActiveCallButtons();

      //return '';
    } else return this.callConnected;
  };
  setenableActiveCallButtons() {
    let data: any = {};
    data = this.enableActiveCallButtons(
      !this.pendingTransferComplete,
      false,
      !this.pendingTransferComplete && this.holdBtnEnabled,
      this.queueServices.getisTransferViewActive(),
      false
    );
    data.dialerStatusText =
      (this.inbound ? 'Inbound: ' : !this.isInternalTransfer ? 'Outbound: ' : 'Internal Transfer: ') +
      (this.contactName == null || this.contactName == ' '
        ? this.phoneNumber == null || this.interactionName == 'Chat'
          ? this.interactionName + ' Connected'
          : this.formatPhoneNumber(this.phoneNumber, '')
        : this.contactName);
     
    this.redrawDialerPanel(data);
  }
   
  redrawDialerPanel = function (data: any) {
    // pendingRedraw = false;
    var isActiveMode = (this.softPhoneActive || this.callActive || this.phoneLocked) && !this.callEnded;
    var dialerControls_visible = !(this.messageOpen || this.confirmOpen || this.lockedOpen || this.errorOpen);
    this.setAllDialerWindowStatus(dialerControls_visible, false, false);
    //dialerControls.height(isActiveMode ? 105 : 75);
    var dialerActiveControls_visible = isActiveMode;
    // dialerInactiveControls.visible(!isActiveMode);
    var phoneNumberClearBtn_visible = !isActiveMode;
    var phoneNumberText_enabled = !isActiveMode;
    

    data.showDialer = dialerControls_visible;
    data.CustomControlEnabled = true;
     

    this.dialerService.setCustomShowDialer(data);
  };
  redraw = function () {
    //pendingRedraw = false;
    var isActiveMode = (this.softPhoneActive || this.callActive || this.phoneLocked) && !this.callEnded;

    var dialerActiveControls = !(this.messageOpen || this.confirmOpen || this.lockedOpen || this.errorOpen);
    this.setAllDialerWindowStatus(isActiveMode, false, false);
    
  };
  callStarted_dialogctrl = function (usingSoftPhone) {
    console.log('callStarted_dialogctrl');
    this.callStarted = true; 
    this.callComplete = false;
  };

  softPhoneCallEnded = function (isdialogcontroller: boolean = false) {
    console.log('softPhoneCallEnded');
     
    call = null;
    //this.conn = null;
    this.callEnded_phnctrl(false, false, false);
     
    this.setSoftPhoneActive(false);
    this.softPhoneActive = false;
     
    this.appService.setSoftPhoneStatus('Ready');
     
    if (
      !this.dialerService.getIsTransferCallRejected() &&
      !this.isInternalTransfer &&
      !this.isListeningIn &&
      !this.dialerService.getDialerCancelledStatus() &&
      this.getCallInProgressStatus()
    ) {
      this.callCompleted(false);
    }
     
    if (this.ispredictiveOpen() && this.Predictive_inbound && !this.dialerService.getDialerCancelledStatus()) this.softPhoneDisconnected();
     
    // if (this.useTwilioClient()) {
    //   this.twilioTokenErrors = 0;
    //   this.twilioUpdateToken(false);
    // }
    /*this.isInternalTransfer = false;*/
    this.isInternalCallConnected = false;
  };

  softPhoneInternalCallEnded = function () {
    console.log('softPhoneInternalCallEnded'); 
    call = null; 
    this.callEnded_phnctrl(false, false, false); 
    this.softPhoneActive = false;
    this.setSoftPhoneActive(false);
  };

  callCompleted = function (noPostCallTimeout) {
    console.log('callCompleted');
    this.dialerService.setStopHoldTimer(true);
    //check the call status one more time
    if (this.disconnectTimeout == null || this.statusFailures < this.disconnectTimeout)
      // this.checkCallStatus(true, function () {
      this.resetCallStatuses();
    // });
    else this.resetCallStatuses();
    this.dialerService.setCallStatus('');
    var alreadyCompleted = false;
    this.callIsConnected = false;
    //userDetailsData = null;
    this.callInProgress = false;
    this.callEnded = true;

    if (isCallConnected) {
      this.stopCallDurationTimer();
      this.queueServices.setCaseDetails_ENABLECONTROLS(false);
      this.setAllDialerWindowStatus(false, false, true);
    }
    // this.setLastCallCompletedTime(new Date());
    this.callConnected = false;
    isCallConnected = false;
     
    if (this.hideCallPrompt) {
      this.disableCallPromptControls = false;
    }
     
    if (this.isFreeDialer) {
      if (this.getisCaseDetailStatus()) {
        //considering , call was made in case detail
        this.dialerService.setStatusMessage('Post-Call (Active)');
        console.log('maincontroller-callcompleted->if ->SetUserstatus - postcall');
        this.appService.setUserStatus(8, this.queueServices.getselectedQueueId());
      } else {
        //considering , call was made in outbound outside case detail
        this.appService.setUserStatus(6, this.queueServices.getselectedQueueId());
      }
    } else {
      this.dialerService.setStatusMessage('Post-Call (Active)');
      console.log('maincontroller-callcompleted-> else-> SetUserstatus - postcall');
      this.appService.setUserStatus(8, this.queueServices.getselectedQueueId());
    } 
    this.onHold = false;
    if (this.dialerService.getwaitingForCallToComplete()) {
      //this.waitingForCallToComplete
      this.dialerService.setwaitingForCallToComplete(false); // this.waitingForCallToComplete = false;
      /*if (this.waitingPrompt != null) this.waitingPrompt.close();*/
      this.confirmDialogComponent.cancel();
      this.confirmDialogComponent.closedialog();
      this.goToNextCall();
    } else {
      //check if any postcalltimeout value is there to show warning alert
      this.checkPostCallTimeout(alreadyCompleted, noPostCallTimeout);
      //if a group transfer is pending and the call just ended, then alert the agent and block them from submitting this record
      if (isGroupTransfer && !groupTransferComplete) {
        clearTimeout(this.groupTransferCheckTimeout);
        //im.UIAlert.open("The transfer was canceled.Press OK to " + (autoCall ? "go to the next record." : "return to the queue and choose a different record."), function () {
        //	goToNextCall();
        //});
        this.postCallTimeoutAlert = false;
        this.resetPostCallTimeout();
        this.confirmDialogComponent
          .confirmdialog(
            '',
            'The transfer has been canceled.Press OK to ' +
            (this.autoCall ? 'go to the next record.' : 'return to the queue and choose a different record.'),
            'OK',
            ''
          )
          .then(confirmed => {
            if (confirmed) {

              this.goToNextCall();
            }
          })
          .catch(() =>
            console.log(
              'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
            )
          );
      }
    }
  };
  callEnded_phnctrl = function (wasTransferred, transferCancelled, alerted) {
    console.log('callEnded_phnctrl');
     
    if (this.getisCaseDetailStatus() && this.queueServices.getCallID() != '') {
      //cls.updateCalls(parentInteractionID);
      this.tmQueueService
        .updateRelatedCalls(this.queueServices.getCallID())
        .subscribe((response: any) => {
          //this.setUserStatus(8, this.selectedQueueId);
        });

    }
    this.transferCancelledBySender = transferCancelled === true;
    this.callTransferred = this.callTransferred || wasTransferred === true;
    //If this is the receiving agent on a transfer that was canceled set transferCancelled to true so it doesn't submit the call in the view.
    if (transferCancelled == undefined && !groupTransferComplete_phnctrl) {
      transferCancelled = true;
    }
 
    this.callEnded_view(false, transferCancelled);
    if (isGroupTransfer_phnctrl && !groupTransferComplete_phnctrl) {
      clearTimeout(this.groupTransferCheckTimeout);
      
    }
    this.callData = null;
    this.inbound = false;
    //this.Predictive_inbound = false;
    isGroupTransfer_phnctrl = false;
    this.callConnected = false;
    //this.isInternalTransfer = false;
    groupTransferComplete_phnctrl = true;
     

    this.interactionType = null;
    //this.transferWindowComponent.CallTransfer_hide.emit();
    this.tmQueueService.setCallTransfer_hide({ value: true });
    // }
  };
  callEnded_view1() {
    this.callEnded = true;
    this.dialerService.setCallDisconnected(true); //Automated cancel button/
    this.dialerService.setShowDialer(false);
  }
  callEnded_view = function (forceCleanup, transferCancelled) {
    console.log('callEnded_view');
    var transferProcessing = this.queueServices.getistransferProcessing();
    if (!transferProcessing || !this.isAway) {
      if (this.softPhoneActive || this.callActive || forceCleanup || transferCancelled) {
        
        this.dialerService.setCallDisconnected(true); //Automated cancel button/
        this.callActive = false;
        this.callEnded = true;
        if (this.isInternalTransfer) {
          // this.internalAddRecipientToggle(false);
        } else {
          this.softPhoneActive = false;
        }
        //enableCallButton(!callConnected && validPhoneNumber(phoneNumberText.value()));
        this.callConnected = false;
        this.isTransferActive = false;
        this.queueServices.setisTransferViewActive(false);
        this.dialerService.setCurrentTransferStep(0);
        this.dialerService.setShowDialer(false);
        
        this.stopCallDurationTimer();
        //clearConferenceList();
        if (!forceCleanup && this.dialerService.getIsCaseDetailFreeDial() && this.dialerService.getIsFreeDialer()) {//|| checkCallStatus
          if (!transferCancelled) {
            //this.controller().submitCall(phoneNumber, contactName, callDuration, isPersonalCall);
            if (!this.callTransferred && !this.transferCancelledBySender) {
                this.submitRelatedCalls((this.dialerService.getCallDuration() ?? 0), this.phoneNumber, this.contactName, '0');
            }
          }
           
        }
        
        this.redraw();
        
      }
    }
  };

  submitRelatedCalls = function (callDuration, phoneNumber, contactName, parentUserID) {
    this.tmQueueService
      .SubmitRelatedCall(this.activityId, this.queueServices.getselectedQueueId(), this.queueServices.getChildCallID(), callDuration, phoneNumber, contactName, this.queueServices.getCallID(), parentUserID)
      .subscribe(data => {

      });
  }
  endCall_main = function (softphoneOnly, agentChatDisconnected) {
    console.log('endCall_main');
    if (this.onHold) {
      this.toggleHold('', undefined);
    }

    if (this.isFreeDialer) {
      if (this.getisCaseDetailStatus()) {
        //considering , call was made in case detail 
        if (!this.isListeningIn && !this.isInternalTransfer) {
          console.log('maincontroller-endcall_main-> if-> SetUserstatus - postcall');
          this.appService.setUserStatus(8, this.queueServices.getselectedQueueId());
        }
      } else {
        //considering , call was made in outbound outside case detail
        //this.appService.setUserStatus(6, this.queueServices.getselectedQueueId());
      }
    } else {
      //this.dialerService.setStatusMessage("Post-Call (Active)");
      //this.appService.setUserStatus(8, this.queueServices.getselectedQueueId());
      if (!this.isListeningIn && !this.isInternalTransfer) {
        console.log('maincontroller-callcompleted->else ->SetUserstatus - postcall');
        this.appService.setUserStatus(8, this.queueServices.getselectedQueueId());
      }
    }

    this.endCall(softphoneOnly, agentChatDisconnected);
    if (!this.onHold) {
      this.softPhoneCallEnded();
    }
  };
  endCall = function (softphoneOnly, agentChatDisconnected) {
    console.log('endCall called');
    this.twilioVoice.hangup();
    call = null;
    this.dialerService.setPredictiveModalState(false);
    if (this.interactionType == 'InboundVideoChat' || this.interactionType == 'InboundTextChat') {
      this.tmQueueService
        .CancelCall(agentChatDisconnected === true, this.queueServices.getGroupTransferInteractionID())
        .subscribe(data => {
          this.interactionType = null;
        });
    }

    this.dialerService.setPredictiveModalState(false);
  };
  // Public Properties
  phoneNumber_view = function (value, autoDial, contact) {
    if (this.phoneEnabled && typeof value === 'string') {
      this.phoneNumber = value;
      if (typeof contact === 'string') this.contactName = contact;
     
    }
    return this.phoneNumber;
  };
  toggleHold = function (newHoldState, uiOnly) {
    
    this.onHold = !this.onHold;
    if (this.toggleHold_main(this.onHold, uiOnly)) {
      //if (this.onHold) {
      //    $(holdBtn._cl_viewElement).removeClass('greenButton iconHoldPause').addClass('orangeButton iconHoldPlay').attr('title', 'Resume ' + interactionName);
      //} else {
      //    $(holdBtn._cl_viewElement).removeClass('orangeButton iconHoldPlay').addClass('greenButton iconHoldPause').attr('title', 'Hold ' + interactionName);
      //}
    } else this.onHold = !this.onHold;
  };

  toggleHold_main = function (state, uiOnly) {
    var isToggle = state === undefined;
    var holdTime;
    if (call || !this.softPhone) {
      if (this.holdPending) return false;
      this.holdPending = true && !uiOnly;
      this.onHold = this.isToggle ? !this.onHold : state;
      if (this.onHold) {
        
      } else {
        if (!this.uiOnly)
           
          console.log('resumeCall called');
        this.tmQueueService.resumeCall(this.queueServices.getCallID(), true, false, '').subscribe(data => {
          this.holdPending = false;
          this.endCall_main(false, false);
          console.log('resumeCall called response');
        });
      }
    
      return true;
    } else this.resetHold();
    return false;
  };
  resetHold = function () {
    this.holdPending = false;
    this.onHold = false;
    // $('#holdBtn').addClass('greenButton iconPause').removeClass('orangeButton iconPlay').find('DIV').html("Hold");
  };

  clearPhoneNumber = function () {
    this.contactName = null;
    this.phoneNumber = null;
    
  };
  softPhoneProcessMessage(msgBody) {
    if (msgBody == 'ping') {
      // clearTimeout(softPhonePingResponseTimeout);
      // softPhonePingTimeout = setTimeout(softPhoneMessagePing, softPhonePingDelay);
      // cls.log('Soft phone ping successful');
    } else {
      //parse the message as JSON
      try {
        var msg = msgBody;
        if (typeof msgBody === 'string') {
          msgBody = decodeURIComponent(decodeURIComponent(msgBody));
          msg = JSON.parse(msgBody);
        }
        this.inbound = msg.Inbound;
        var controller = msg.Controller;
        // theQueueID = msg.QueueID;
        this.interactionID = msg.InteractionID;
        this.queueID = this.queueServices.getselectedQueueId();
        this.queueServices.setGroupTransferInteractionID('');
        this.queueServices.setCaseDetailsLoaded(false);
        this.queueServices.setSelectedNewUserId(null);
        this.dialerService.setIsFreeDialer(false);
        this.queueServices.setChildCallID('');
        //this.isDialogController = true;
        switch (controller) {
          case 'Dialog':
            if (this.ispredictiveOpen()) {
              //    predictiveWaitBlocker.close();
              this.setPredictiveOpen(false);
              // cls.redirect(controller + '/' + theQueueID + '-' + (inbound ? 'inbound_' : '') + 'i' + interactionID + '-0' + (theQueueID == queueID ? '' : ('-' + queueID)), false, true);
              this.Predictiveclose();
              let urlcontent =
                this.queueID + '-' + (this.inbound ? 'inbound_' : '') + 'i' + this.interactionID + '-0' + (msg.QueueID == this.queueID ? '' : '-' + this.queueID);
              var data: any = {};
              data.dialerType = this.queueDialerType;
              data.interactionType = this.QueueInteractionType;
              data.navigateURL = urlcontent;
              this.isSetActionItemCompleted = false;
              groupTransferComplete = false;
              this.CallCurrentActionItems(this.queueID, data);
              this.Showdialer(false, true);
              this.showPhoneMessaging('');
             
            }
            break;
          case 'ExternalSystem':
           
            break;
        }
      } catch (e) {
        console.warn('Unexpected SIP message: ' + msgBody);
      }
    }
  }

  navigateToSalesForcePage(baseURL: any, crmUserID: any, crmCaseID: any) {
    Utils.navigateToSalesForcePage(baseURL, crmUserID, crmCaseID);
    this.configService.OpenUrlInNewTab(baseURL.value);
  }

  RedirectToCaseDetails() {
    if (this.interactionID == null) {
      this.queueServices.setQueueRoute(this.router.url);
      if (this.CalleeeUserID != null && this.CalleeeUserID != -1) {
        this.appService.setActionItemId(this.queueID + '-' + this.CalleeeUserID + '-' + null);
        this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/caseDetails']);
      } else {
        this.appService.setActionItemId(this.queueServices.getselectedQueueId() + '-' + null + '-' + null);
        this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/ConfirmUser']);
      }
    } else {
      this.queueServices.getInboundNumber(this.interactionID).subscribe(data => {
        this.dialerService.setPhoneNo(data.Response.Data);
        this.queueServices.setQueueRoute(this.router.url);
        if (this.CalleeeUserID != null && this.CalleeeUserID != -1) {
          this.appService.setActionItemId(this.queueID + '-' + this.CalleeeUserID + '-' + null);
          this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/caseDetails']);
        } else {
          this.appService.setActionItemId(this.queueServices.getselectedQueueId() + '-' + null + '-' + null);
          this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/ConfirmUser']);
        }
      });
    }
  }
  RedirectToCaseDetailFromcallTransfer(data) {
    this.addSearchParameterArray = [];
    this.dialerService.setPhoneNo(data.PhoneNumber);
    this.queueServices.setQueueRoute(this.router.url);
    this.addSearchParameterArray.push({
      type: 'Phone #',
      value: data.PhoneNumber,
    });
    console.log('outbound->RedirectToCaseDetails', data);
    this.queueServices.findRecord(this.addSearchParameterArray)
      .pipe(
        map((data: any) => {
          if (data.Response.Data != null && (data.Response.Data.length > 1 || data.Response.Data.length == 0)) {
            console.log('outbound->RedirectToCaseDetails->response ConfirmUser');
            this.appService.setActionItemId(this.queueServices.getselectedQueueId() + '-' + null + '-' + null);
            this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/ConfirmUser']);
          } else {
            console.log('outbound->RedirectToCaseDetails->response caseDetails');
            this.appService.setActionItemId(this.queueServices.getselectedQueueId() + '-' + data.Response.Data[0].UserID + '-' + null);
            this.router.navigate([Utils.fetch('clientAbbreviation') + '/Queue/caseDetails']);
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }
  //Automated Code End

  //PredictiveWaitBlocker Code Start

  Predictiveopen = function (_queueID: string, _inbound: boolean, _type: string): void {
    this.setPredictiveOpen(true);
    if(!this.softPhone){
      this.initializeSoftPhone();
    }
    console.log('Predictiveopen called');
    window.clearTimeout(this.pendingTimer);
    window.clearTimeout(this.checkConnectedTimer);
    this.dialerService.setPredictiveModalState(true);
    if (this.waitMsg || this.PhoneEnabled()) {
      this.pendingOpen = null;
      this.Predictive_inbound = !!_inbound;
      this.interactionType = _type;
      this.interactionName = _type === 'InboundTextChat' || _type === 'InboundVideoChat' ? 'Chat' : 'Call';
      this.showPhoneMessaging(
        (this.softPhone
          ? 'Connecting your softphone.'
          : this.inbound
            ? 'Waiting for an inbound ' + this.interactionName?.toLowerCase() + '.'
            : 'Retrieving the next ' + this.interactionName?.toLowerCase() + '.') + ' Please wait...'
      );
     
      this.callId = null;
      this.queueServices.setCallID(null);
      this.updateStatusSet(false);
      console.log('Predictiveopen updateStatusSet ->', this.statusSet);
      this.appService.setUserStatus(11, this.queueServices.getselectedQueueId());
      this.waitingForCall();
      this.TranscriptReset();
    
    } else {
      const self = this;
      this.pendingOpen = {
        queueID: _queueID,
        inbound: _inbound,
        type: _type,
      };
      this.pendingTimer = window.setTimeout(function () {
        self.open(this.pendingOpen.queueID, this.pendingOpen.inbound, this.pendingOpen.type);
      }, 500);
    }
  };

  isOpen = function (): boolean {
    const isOpen: boolean = false; //cls.superclass().isOpen.apply(this, arguments);
    //return (isOpen || (phoneController && phoneController.phoneEnabled() && phoneController.showMessage() && !phoneController.showError()));

    return isOpen;
  };
  PhoneEnabled = function (value) {
    if (typeof value === 'boolean') {
      this.phoneEnabled = value;
    
    }
    this.phoneEnabled = true; //Hardcoded
    return this.phoneEnabled;
  };
  Predictiveclose = function (): void {
    console.log('Predictive Close Called');
    // window.clearTimeout(pendingTimer);
    window.clearTimeout(this.checkConnectedTimer);
    clearTimeout(this.waitingTimeout);
    this.setPredictiveOpen(false);
    this.isSoftphoneErrorOccurred = false;
   
  };
 

  softPhoneConnected = function (): void {
    this.showPhoneMessaging(
      (this.Predictive_inbound
        ? 'Waiting for an inbound ' + this.interactionName?.toLowerCase() + '.'
        : 'Retrieving the next ' + this.interactionName?.toLowerCase() + '.') + ' Please wait...'
    );
  };

  updateStatusSet = function (val: boolean): void {
    this.statusSet = val;
  };
 

  hideTimer = function (): void {
    
  };

  

  updateTimer = function (): void {
    //  timerText.text(im.Utils.formatDuration(timer, 's')).visible(true);
  };

  eNotificationCloseHandler = function (e: any): void {
    //let notification: this.NotificationItem | null = null;
    let index: number = -1;
    //for (let x = 0, y = notifications.length; x < y; x++) {
    //    if (notifications[x] === e.target()) {
    //        notification = notifications[x];
    //        index = x;
    //        break;
    //    }
    //}
    //if (notification != null) {
    //    notificationHolder.removeSubView(notification);
    //    notifications.splice(index, 1);
    //}
  };

  waitingForCall = function (): void {
    //console.log('waitingForCall called');
    if (this.ispredictiveOpen()) {
      //cls.cl().main().mainController().profileStatus().setAgentStatus(11);
      if (!this.statusSet) {
        // im.DataService.instance().GetUserStatus({ queueID: this.queueID }, function (statusID: number) {
        this.tmQueueService.getUserStatus(this.queueServices.getselectedQueueId()).subscribe(res => {
          if (res.Response.Data !== 6) {
            //console.log("waitingForCall res.Response.Data !== 6");
            //im.DataService.instance().SetUserStatus({ statusID: 6, queueID: this.queueID }, function () {
            this.tmQueueService.setUserStatus(6, this.queueServices.getselectedQueueId()).subscribe(data => {
              this.updateStatusSet(true);
              // console.log("waitingForCall tmQueueService.setUserStatus");
              this.waitingForCall();
            });
          } else {
            this.updateStatusSet(true);
            this.waitingForCall();
          }
        });
        return;
      }
      if (this.waitingTimeout) {
        clearTimeout(this.waitingTimeout);
        this.waitingTimeout = null;
      }

      if (!this.GetDialerCancelledStatus() && !this.callConnected) {
        //im.InteractionService.instance().WaitingForCall({ queueID: this.queueID, agentCallID: this.callID }, successCallback, errorCallback);
        this.tmQueueService
          .waitingForCall(this.queueServices.getselectedQueueId(), this.queueServices.getCallID())
          .subscribe(data => {
            //console.log("waitingForCall response", data);
            this.callId = data.Response.Data.CallID;
            this.queueServices.setCallID(data.Response.Data.CallID);
            //console.log('waiting for callid:' + this.queueServices.getCallID());
            // console.log("waitingForCall tmQueueService.waitingForCall before success");
            this.successCallback(data.Response.Data);
            //this.isInboundCallConnected();
          }, this.errorCallback);
      } else {
        this.Predictiveclose();
        if (!this.callConnected) {
          this.disconnectTwilio();
        }
      }
    }
  };
  errorCallback = function (errorCode, details) {
    console.log('waitingForCall Error Callback');
    if (this.message === 'Empty queue') {
      //im.UIAlert.open('There are no more records in this queue.');
    } else if (this.ispredictiveOpen()) {
      if (details.indexOf('Error getting application lock') !== -1) {
        this.waitingTimeout = setTimeout(this.waitingForCall, 5000);
      } else if (retryCount < maxRetry) {
        retryCount++;
        //im.InteractionService.instance().WaitingForCall({ queueID: this.queueID, agentCallID: this.callID }, successCallback, errorCallback);
      } else {
        const message: string =
          'An unknown error occurred while waiting for the next ' +
          this.interactionName?.toLowerCase() +
          '.<br /><br />Press OK to reload the page.<br />If this error persists, please contact Onvida.';
        if (this.phoneController.phoneEnabled()) {
          this.phoneController.showError(true, message, details);
        } else {
          //im.UIAlert.open(message + '<br /><br />Error details: "' + details + '"', function () {
          //    cls.cl().main().mainController().refresh();
          //});
        }
      }
    }
  };
  successCallback = function (response) {
    //if (this.isOpen()) {
    if (!this.GetDialerCancelledStatus()) {
      if (response && response.Connecting === true && response.InteractionID) {
        //it will call when progressive and dialmode=2
        //this.close();
        this.Predictiveclose();
        this.setPredictiveOpen(false);
        
        let urlcontent =
          this.queueServices.getselectedQueueId() +
          '-' +
          (response.Inbound ? 'inbound_i' : 'i') +
          response.InteractionID;
        this.interactionID = response.InteractionID;
        var data: any = {};
        data.dialerType = this.queueDialerType;
        data.interactionType = this.QueueInteractionType;
        data.navigateURL = urlcontent;
        this.isSetActionItemCompleted = false;
        groupTransferComplete = false;
        this.CallCurrentActionItems(this.queueServices.getselectedQueueId(), data);
        this.Showdialer(false);
        this.showPhoneMessaging('');
      } else if (response && response.UserID && response.UserID > 0) {
        //it will call when progressive and dialmode=1
        //this.close();
        this.setPredictiveOpen(false);
        let actionItemID: string =
          this.queueServices.getselectedQueueId() + '-' + response.UserID + '-' + response.CaseID;
        actionItemID += response.ScheduledInteractionID ? '-si' + response.ScheduledInteractionID : '';
       
        var data: any = {};
        data.dialerType = this.queueDialerType;
        data.interactionType = this.QueueInteractionType;
        data.navigateURL = actionItemID;
        this.isSetActionItemCompleted = false;
        groupTransferComplete = false;
        this.isSoftphoneErrorOccurred = false;
        this.CallCurrentActionItems(this.queueServices.getselectedQueueId(), data);
        this.setAllDialerWindowStatus(false, false, false);
        this.Showdialer(false, false);
        this.showPhoneMessaging('');

        this.newCallSnd.play();
      } else {
        if (response.CallID != null) {
          this.callId = response.CallID;
          this.queueServices.setCallID(response.CallID);
          // console.log('successCallback Callid:' + response.CallID);
        }
        if (this.queueServices.getCallID() == null && this.softPhone) {
          this.showPhoneMessaging('Connecting your softphone. Please wait...');
          this.hideTimer();
        }
        this.waitingTimeout = setTimeout(this.waitingForCall.bind(this), 5000);
        
      }
    } else {
      this.Predictiveclose();
      this.disconnectTwilio();
    }
    //}
  };
  checkCallConnected = function (): void {
    clearTimeout(this.checkConnectedTimer);
    if (this.ispredictiveOpen()) {
      this.tmQueueService.isInboundCallConnected().subscribe(data => {
        this.checkCallConnected_successCallback(data.Response.Data),
          this.checkCallConnected_errorCallback(data.Response.Data, null);
      });
      //im.InteractionService.instance()[inbound ? 'IsInboundCallConnected' : 'IsPredictiveCallConnected'](successCallback, errorCallback);
    }
  };

  checkCallConnected_errorCallback(errorCode: number, details: string): void {
    if (this.checkCallConnected_retryCount < this.checkCallConnected_maxRetry) {
      this.checkCallConnected_retryCount++;
      this.tmQueueService.isInboundCallConnected().subscribe(data => {
        this.checkCallConnected_successCallback(data.Response.Data), this.checkCallConnected_errorCallback(null, null);
      });
      // im.InteractionService.instance()[inbound ? 'IsInboundCallConnected' : 'IsPredictiveCallConnected'](successCallback, errorCallback);
    }  
  }
  checkCallConnected_successCallback(response: any): void {
    if (this.ispredictiveOpen()) {
      var isConnected: boolean = response.Connected,
        isInbound: boolean = response.Inbound,
        theQueueID: string = response.QueueID,
        interactionID = response.InteractionID;
      if (isConnected) {
        this.Predictiveclose();
        let actionItemID: string =
          +theQueueID +
          '-' +
          (isInbound ? 'inbound_' : '') +
          'i' +
          interactionID +
          '-0' +
          (theQueueID === this.queueServices.getselectedQueueId() ? '' : '-' + this.queueServices.getselectedQueueId());
        // cls.redirect('Dialog/' + theQueueID + '-' + (isInbound ? 'inbound_' : '') + 'i' + interactionID + '-0' + (theQueueID === queueID ? '' : ('-' + queueID)), false, true);
        this.CallCurrentActionItems(theQueueID, actionItemID);
      }
      //this.checkConnectedTimer = setTimeout(this.checkCallConnected, 3000);
      else this.checkConnectedTimer = setTimeout(this.checkCallConnected.bind(this), 3000);
    }
  }
  eSubmitHandler() {
    if (
      this.dialerType != 'Manual' &&
      this.dialerType != 'External' &&
      this.postCallTimeout &&
      this.postCallTimeout > 0
    ) {
      this.updatePostCallTimeout(false);
      clearInterval(this.postCallTimeoutInterval);
      //this.postCallTimeoutInterval = setInterval(this.updatePostCallTimeout, 1000);
      this.postCallTimeoutInterval = setTimeout(this.updatePostCallTimeout.bind(this), 1000);
    }
    this.goToNextCall(false, false, false);
  }
  goToNextCall(skip, allowRedial, stayOnPage) {
    this.isRedial = false;
    groupTransferComplete = false;
    if (stayOnPage) {
      this.isRedial = true;
      if (this.dialerType == 'Predictive') {
        //  cls.redirect('Dialog/' + actionItemID + '-redial', null, true);
      } else {
        //  cls.redirect('Dialog/' + queueID + '-redial_' + (userID || '0') + '-' + caseID, null, true);
      }
    } else if (allowRedial && !this.inbound && this.dialerType != 'Keypad') {
      //if the call was dropped, ask the user if they would like to re-dial the same user
      if (this.redialAlert == null) {
         
      }
       
    } else if (this.lastqueue != null) {
      
    } else if (
      this.dialerType == 'Power' ||
      this.dialerType == 'Preview' ||
      this.dialerType == 'Progressive' ||
      this.dialerType == 'Predictive' ||
      this.dialerType == 'AutomatedInbound' ||
      this.dialerType == 'Keypad'
    ) {
       
      if (this.autoAdvanceEnabled || this.dialerType == 'Keypad') {
        if (this.dialerType == 'Progressive' || this.dialerType == 'Predictive') {
          //cls.redirect('Dialog/' + queueID + '-auto');
        } else if (this.dialerType == 'AutomatedInbound') {
          //cls.redirect('Dialog/' + queueID + '-inbound_auto');
        }  
      } else {
        // cls.cl().main().mainController().setStatusAway();
      }
    } else {
      //cls.redirect('/');
    }
    const returnData = {
      activityID: this.activityId,
      actionItem: this.actionItemToReturn,
      isExternalTransfer: false,
      queueType: this.queueType,
      transferCaseID: this.transferCaseID,
      triggerType: 'PostTransfer',
    };
    //this.caseDetailComponent.Transfer_SUBMIT_CALL.emit(returnData);
    this.setSaveChanges(true);
    this.tmQueueService.setTransfer_SUBMIT_CALL(returnData);
  }

  checkPostCallTimeout(alreadyCompleted, noPostCallTimeout) {
    if (
      !alreadyCompleted && noPostCallTimeout !== true && this.isCaseDetail == true && this.queueDialerType != 'Manual' && this.queueDialerType != 'External' && this.postCallTimeout && this.postCallTimeout > 0) {
      this.postCallTimeoutRemaining = this.postCallTimeout;
      //requestMoreTimeBtn.visible(false);
      this.requestMoreTimeBtn = false;
      this.updatePostCallTimeout(true);
      this.postCallTimeoutAlert = true;
      clearInterval(this.postCallTimeoutInterval);
      //this.postCallTimeoutInterval = setInterval(this.updatePostCallTimeout, 1000);

      this.postCallTimeoutInterval = setInterval(() => {
        this.updatePostCallTimeout(false);
      }, 1000);

    } else if (noPostCallTimeout === true) {
      this.postCallTimeoutAlert = false;
      clearInterval(this.postCallTimeoutInterval);
    }
  }

  updatePostCallTimeout = function (skipDecrement) {
    if (!skipDecrement) this.postCallTimeoutRemaining--;
    if (this.postCallTimeoutRemaining <= 0) {
      // dataService.PostCallTimedOut();
      // postCallTimeoutAlert.visible(false);
      this.postCallTimeoutAlert = false;
      clearInterval(this.postCallTimeoutInterval);
     
      this.postCallTimeoutFailure();
      
    }
    // postCallTimeoutText.text('Warning: You have ' + this.postCallTimeoutRemaining + ' seconds to submit this record.');
    this.postCallTimeoutText = ('Warning: You have ' + this.postCallTimeoutRemaining + ' seconds to submit this record.');
    if (this.postCallTimeoutRemaining <= this.postCallTimeout / 2) {
      this.requestMoreTimeBtn = (true);
    } 
  }
  resetPostCallTimeout() {
    this.postCallTimeoutAlert = false;
    clearInterval(this.postCallTimeoutInterval);
  }
  eRequestMoreTimeHandler = function () {
    this.requestMoreTimeBtn = (false);
    clearInterval(this.postCallTimeoutInterval);
    this.postCallTimeoutRemaining += this.postCallTimeout;
    this.updatePostCallTimeout(true);
  
    this.postCallTimeoutInterval = setInterval(() => {
      this.updatePostCallTimeout(false);
    }, 1000);
    ////alert the server
    //dataService.RequestedTimeoutExtension();
  }

  postCallTimeoutFailure = function () {
    //set the status to away
    
    this.appService.setUserStatus(9, this.queueServices.getselectedQueueId());
    //alert the user
    var msg = 'You failed to submit the record in the allowed time. Please press OK to finish submitting the record.';
     

    this.confirmDialogComponent
      .confirmdialog(
        '',
        msg,
        'OK',
        ''
      )
      .then(confirmed => {
        if (confirmed) {
          console.log('maincontroller-postCallTimeoutFailure-confirmDialogComponent ->SetUserstatus - postcall');
          this.appService.setUserStatus(8, this.queueServices.getselectedQueueId());
          this.postCallTimeoutRemaining = this.postCallTimeout;
          this.requestMoreTimeBtn = (false);
          this.updatePostCallTimeout(true);
          this.postCallTimeoutAlert = (true);
          clearInterval(this.postCallTimeoutInterval);

          this.postCallTimeoutInterval = setInterval(() => {
            this.updatePostCallTimeout(false);
          }, 1000);
        }
      })
      .catch(() =>
        console.log(
          'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
        )
      );
  }
  showPhoneMessaging = function (message: string): void {
     
    this.dialerService.setdialerMessage(message);
  };

  
  //PredictiveWaitBlocker Code End
 
  resumeCalling(): void {
    if (this.automatedExternal || this.manualExternal) {
      return;
    }
  console.log('resumeCalling');
    const shouldWaitForCall =
      this.automatedQueue &&
      (
        this.predictiveQueue ||
        this.progressiveQueue ||
        (this.automatedInbound && !this.blendedLastQueue)
      );
  
    if (shouldWaitForCall) {
      this.waitForCall(null);
    }
  }
  //Automated Call End

  formatPhoneNumber = function (number, country) {
    switch (country) {
      case 'US':
      default:
        number = number.replace(/\D/g, '');
        if (number.charAt(0) == '1') number = number.substring(1);
        if (number.length == 7) return number.substring(0, 3) + '-' + number.substring(3);
        if (number.length == 10)
          return '(' + number.substring(0, 3) + ') ' + number.substring(3, 6) + '-' + number.substring(6);
        if (number.length > 10)
          return (
            '(' +
            number.substring(0, 3) +
            ') ' +
            number.substring(3, 6) +
            '-' +
            number.substring(6, 10) +
            ' x' +
            number.substring(10)
          );
        return number;
    }
  };
  eRemoteLoggedOffHandler(message: string) {
    var autologout = true;
    this.confirmDialogComponent
      .confirmdialog('Remote Log Off', message, 'Ok', '')
      .then(confirmed => {
        if (confirmed) {
          autologout = false;
          this.resetloggedout();
        }
      })
      .catch(() =>
        console.log(
          'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
        )
      );
    if (autologout) {
      this.autoLogoff();
    }
  }
  checkGroupTransferStatus = function () {
    //this.tmQueueService.isInboundCallConnected().subscribe(data => {
    //    this.checkCallConnected_successCallback((data.Response.Data)), this.checkCallConnected_errorCallback(data.Response.Data, null)
    //});
    this.tmQueueService.GetGroupTransferStatus(this.queueServices.getCallID()).subscribe(data => {
      var status = data.Response.Data;
      if (!this.callEnded) {
        switch (status) {
          case 'Complete':
            //if the transfer is complete, allow transfers
            groupTransferComplete = true;
            this.pendingTransferComplete_phnview(false);
            break;
          case 'Canceled':
            //if the transfer was canceled, alert the agent
            //im.UIAlert.open("<p>The transfer has been canceled.</p><p>Press OK to " + (this.autoCall ? "go to the next record." : "return to the queue and choose a different record.") + "</p>", function () {
            //    this.goToNextCall();
            //});
            this.confirmDialogComponent
              .confirmdialog(
                '',
                'The transfer has been canceled.Press OK to ' +
                (this.autoCall ? 'go to the next record.' : 'return to the queue and choose a different record.'),
                'OK',
                ''
              )
              .then(confirmed => {
                if (confirmed) {
                  this.goToNextCall();
                }
              })
              .catch(() =>
                console.log(
                  'User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'
                )
              );
            break;
          case 'Pending':
            //if the transfer is still pending, then check again in two seconds
            this.groupTransferCheckTimeout = setTimeout(this.checkGroupTransferStatus.bind(this), 2000);
            break;
        }
      }
    });
  };

  pendingTransferComplete_phnview = function (value) {
    //if (typeof value == 'undefined')
    //    return cls.view().pendingTransferComplete();
    //cls.view().pendingTransferComplete(value);
    this.groupTransferComplete_phnctrl = true;
    groupTransferComplete = true;
    this.pendingTransferComplete = !!value;
    if (this.pendingTransferComplete && this.callConnected)
      this.enableActiveCallButtons(true, false, this.holdBtnEnabled);
    //return cls;
  };

  eListentInHandler(ismute: boolean, isListenIn: boolean) {
    this.isListeningIn = isListenIn;
    this.ListenInisMuted = ismute;
  }
  SendPreferences(RecordAgentScreen) {
    // console.log('Main Ctrl SendPreferences');
    this.WindowsWrapper.SendPreferences(RecordAgentScreen);
  }

  ispredictiveOpen() {
    return ispredictiveopen;
  }
  setPredictiveOpen(val: boolean) {
    ispredictiveopen = val;
  }

  isInternalTransferCall() {
    return this.isInternalCallConnected;
  }

  getAgentStatus() {
    return this.ProfileInfo.getAgentStatus();
  }

  getRequestType() {
    return this.requestType;
  }

  setAllDialerWindowStatus(showDialer, showWaitingForcallWindow, showCallDurationWindow) {
    this.showDialer = showDialer;
    this.showWaitingForcallWindow = showWaitingForcallWindow;
    this.showCallDurationWindow = showCallDurationWindow;
  }

  getShowDialerWindowStatus() {
    return this.showDialer;
  }

  getWaitingForcallWindowStatus() {
    return this.showWaitingForcallWindow;
  }

  getshowCallDurationWindowStatus() {
    return this.showCallDurationWindow;
  }
  setshowCallDurationWindowStatus() {
    return (this.showCallDurationWindow = false);
  }
  getcallDuraton() {
    return this.callDuraton;
  }
  getformattedCallDuration() {
    return this.formattedCallDuration;
  }

  startCallDurationTimer() {
    //  console.log('startCallDurationTimer called');
    this.callDuraton = 0;
    clearInterval(this.callTimer);
    this.callTimer = setInterval(() => {
      this.callDuraton++;

      this.formattedCallDuration = this.formatCallDuration(this.callDuraton);
      // console.log('startCallDurationTimer callDuraton', this.formattedCallDuration);
    }, 1000);
  }

  stopCallDurationTimer() {
    console.log('stopCallDurationTimer called');
    this.callDuraton = 0;
    clearInterval(this.callTimer);
  }

  formatCallDuration(seconds) {
    const hoursLeft = Math.floor(seconds / 3600);
    const min = Math.floor((seconds - hoursLeft * 3600) / 60);
    let secondsLeft = seconds - hoursLeft * 3600 - min * 60;
    secondsLeft = Math.round(secondsLeft * 100) / 100;
    let answer = hoursLeft < 10 ? '0' + hoursLeft : hoursLeft;
    answer += ':' + (min < 10 ? '0' + min : min);
    answer += ':' + (secondsLeft < 10 ? '0' + secondsLeft : secondsLeft);
    return answer;
  }

  setSoftPhoneActive = function (value) {
    if (this.phoneEnabled && typeof value === 'boolean') {
      this.softPhoneActive = value;
      //this.redraw();
      // return cls;
    }
    return this.softPhoneActive;
  };

  getEnterRecord() {
    return this.enterRecord;
  }
  setEnterRecord(val) {
    this.enterRecord = val;
    if (val && val != null) this.queueServices.setEnterRecordTime(val ? this.convertServerDate(val) : val);
    else this.queueServices.setEnterRecordTime(val);
  }

  getCallInProgressStatus = function () {
    return this.callInProgress;
  };

  setCallInProgressStatus = function (val: boolean) {
    this.callInProgress = val;
  };

  setisOutboundCallStarted = function (value: any) {
    console.log('isOutboundCallStarted subscribe trigged');
    if (value && value.isOutboundCallConnected) {
      this.resetCallStatuses();

      this.isOutbound = true;
      //this.isDialogController = true;
      //this.isInternalTransfer = false;
      this.callStarted_main({
        number: value.OutBoundNumber,
        contact: null,
        inbound: false,
      });
      this.callEnded = false;
      console.log('isOutboundCallStarted subscribed trigged 2', value.data);

      if (this.getisCaseDetailStatus()) {
        //It should call if call starting from pre-call
        console.log('isOutboundCallStarted subscribe trigged 3');
        this.updateCallStatus(value.data, false);
      }
    }
  };

  setSearchUserSelected(val) {
    this.isUserSelected = val;
  }

  getSearchUserSelected() {
    return this.isUserSelected;
  }

  setisCaseDetail(val) {
    this.isCaseDetail = val;
  }

  getisCaseDetailStatus() {
    return this.isCaseDetail;
  }
  setInteractionType(val) {
    this.QueueInteractionType = val;
  }
  getInteractionType() {
    return this.QueueInteractionType;
  }
  getInteractionName() {
    return this.interactionName;
  }

  TranscriptReset() {
    this.transcriptService.SetEmpty();
    console.log('Reset Transcript..');
    //this.callQuality.clearBanner();
  }
  getenableDialManuallyStatus() {
    return this.enableDialManuallyButton;
  }
  getDialerType() {
    return this.queueDialerType;
  }
  setDialerType(val) {
    this.queueDialerType = val;
  }
  setQueueInfoDetail(val) {
    this.QueueInfoDetail = val;
  }
  setenableDialManuallyStatus(val) {
    this.enableDialManuallyButton = val;
  }
  getQueueInfoDetail() {
    return this.QueueInfoDetail;
  }
  getCallPromptControlsActiveStatus() {
    return this.disableCallPromptControls;
  }
  setCallPromptControlsActiveStatus(val) {
    this.disableCallPromptControls = val;
  }

  getbackBtn() {
    return this.backBtn;
  }
  setbackBtn(val) {
    this.backBtn = val;
  }

  showValidationError(message, enableValidationModal, DisplayvalidationModal, issignalRAlert): void {
    //if (issignalRAlert) {
    console.log('call failure popup triggered:', this.isSubmitfailurePopupdisplayed)
    if (!this.isSubmitfailurePopupdisplayed) {
      this.isSubmitfailurePopupdisplayed = true;
      this.validationErrorMessage = message;
      this.showValidationModal = enableValidationModal;
      this.validationModalDisplay = DisplayvalidationModal;
    }
    //this.setAllDialerWindowStatus(false, false, false);
    //}
    //else {

    //}

  }
  resetValidationModal() {
    this.validationErrorMessage = '';
    this.showValidationModal = false;
    this.validationModalDisplay = 'none';
  }
  getValidationModalStatus() {
    return this.showValidationModal;
  }
  getvalidationErrorMessage() {
    return this.validationErrorMessage;
  }
  getDisplayvalidationModal() {
    return this.validationModalDisplay;
  }

  getSoftPhoneStatus() {
    return this.appService.getSoftPhoneStatus();
  }
  getcurrentRecordUserID() {
    return this.currentRecordUserID;
  }
  setcurrentRecordUserID(currentRecordUserID) {
    this.currentRecordUserID = currentRecordUserID;
  }

  setLastCallCompletedTime(value) {
    this.LastCallCompletedTime = value;
  }
  getLastCallCompletedTime() {
    return this.LastCallCompletedTime;
  }

  setshowSearchDialog(value) {
    this.showSearchDialog = value;
  }
  getshowSearchDialog() {
    return this.showSearchDialog;
  }
  setcallTransferred(val) {
    this.callTransferred = val;
  }
  CheckLastCallCompletedTimeBeforeCall() {
    var sec = this.getMinutesDifference(this.LastCallCompletedTime ?? new Date(), new Date())
    // console.log('getuser called in seconds', sec)
    var delaysec = 0;
    if (this.LastCallCompletedTime && sec < 5) {

      delaysec = 5000;//5 sec
    }
    return delaysec;
  }

  getMinutesDifference(date1, date2) {
    const diffInMilliseconds = Math.abs(date2.getTime() - date1.getTime());
    // const diffInMinutes = diffInMilliseconds / 60000;
    const diffInsec = diffInMilliseconds / 1000;
    return Math.round(diffInsec); // Or Math.floor(diffInMinutes) for whole minutes
  }
  // Configure QNX PCH and BCH items
  setItemsForQNX(userType: string, customerID: string): string {
    //const baseURL = this.configService.geturl(Utils.fetch('clientAbbreviation'));
    const baseURL = this.webStorageService.getItemFromSessionStorage('loginParams')?.ExternalAPIURL;
    const envId = 1;
    const deepLinkFlag = 'Y';

    userType = userType?.toLowerCase();
    const clientAbbreviation = Utils.fetch('clientAbbreviation');
      if ("AHP" === clientAbbreviation) {
        //return `${baseURL}`;
        let ahpQnxtURL = `${baseURL}`;
        let ahpQnxtBaseURL = ahpQnxtURL.split('Master/')[0];
        if (userType === 'provider') {
          ahpQnxtBaseURL += `QProvider/ProviderMain.aspx?p=/QNXTALL/QNXT/QProvider/ProviderMainTab.aspx?ProviderId=${customerID}`;
          return ahpQnxtBaseURL;
        }
        if (userType === 'member') {
          ahpQnxtBaseURL += `QMember/master/membermain.aspx`;
          return ahpQnxtBaseURL;
        }
        return ahpQnxtURL;
      }

    // Default fallback URL if no ID is present
    if (!customerID || customerID.trim() === '') {
      return `${baseURL}QNXT/`;
    }
    let fullURL = `${baseURL}QNXT/Master/Index.aspx?${baseURL}QNXT/`;

    if (userType === 'member') {
      fullURL += `QMember/master/membermain.aspx?callingscreen=deepLink&envId=${envId}&deepLink=${deepLinkFlag}&member=${customerID}`;
    }
    else if (userType === 'provider') {
      fullURL += `QProvider/ProviderMain.aspx?screen=ProviderSummary&callingscreen=deepLink&envId=${envId}&deepLink=${deepLinkFlag}&ProviderId=${customerID}`;
    }

    return fullURL;
  }
  getAgentCurrentStatus() {
    return this.ProfileInfo.getStatusLabel();
  }

  setistransferedcallanswered(value) {
    this.Iscallanswered = value;
  }
  getistransferedcallanswered() {
    return this.Iscallanswered;
  }

  setSaveChanges(value) {
    this.isTransfercallInitiated = value;
  }
  setIsUnknownContact(value) {
    this.IsUnknownContact = value;
  }
  getIsUnknownContact() {
    return this.IsUnknownContact;
  }
  setIsCaseUserUnmapped(value) {
    this.IsCaseUserUnmapped = value;
  }
  getIsCaseUserUnmapped() {
    return this.IsCaseUserUnmapped;
  }
  setUnmappedCaseID(value) {
    this.UnmappedCaseID = value;
  }
  getUnmappedCaseID() {
    return this.UnmappedCaseID;
  }
  setUnmappedUserID(value) {
    this.UnmappedUserID = value;
  }
  getUnmappedUserID() {
    return this.UnmappedUserID;
  }
  setHideUnknownContact(value) {
    this.HideUnknownContact = value;
  }
  getHideUnknownContact() {
    return this.HideUnknownContact;
  }
  setIsReadOnlyCase(value) {
    this.IsReadOnlyCase = value;
  }
  getIsReadOnlyCase() {
    return this.IsReadOnlyCase;
  }
  getSaveChanges() {
    return this.isTransfercallInitiated;
  }
  resetloggedout() {
    this.router.navigate([this.clientAbbreviation + '']);
    this.appService.setCurrentMenu(null);
    Utils.store('clientAbbreviation', null);
    this.userService.logout();
  }
  autoLogoff() {
    let timerId = setTimeout(() => {
      clearTimeout(timerId); // Cancels the timeout
      this.resetloggedout();
    }, 15000);
  }

  setactionItemToReturn(value: any) {
    this.actionItemToReturn = value;
  }
  LogConsoleErrors(err: any) {
    try {
      const code = err?.code ?? err?.name;
      const msg = typeof err?.message === 'string' ? err.message : String(err);
      const key = this.makeKey('device', code, msg);
      //const key = `${source}|${code}|${msg}|${agentId}|${callSid}`;
      if (this.shouldSend(key)) {

        console.log('twilio error sending to api', key);
        this.userService.LogConsoleErrors(key, err.explanation.trim().slice(0, 2000)).subscribe(data => {

        });
      } else {
        console.log('Restricted to send twilio error sending to api, since same', key);
        // optionally count local suppressions or write to console
      }
    }
    catch (e) { }
    }

    

    private twilioErrorMap = new Map<number, TwilioErrorTracker>();

    // After this many occurrences within the window, stop DB logging + alert.
    public ERROR_THRESHOLD = 15;// this.getErrorThreshold();

    // Reset the counter if no occurrence happens within this window (ms).
    private readonly ERROR_WINDOW_MS = 5 * 60000; // 5 minutes

    // Optional cooldown before we allow logging the same code again (ms).
    private readonly ERROR_COOLDOWN_MS = 5 * 60000; // 5 minutes

    private handleTwilioErrorLogging(error: any): void {
        const code = this.twilioVoice.getTwilioErrorCode(error);
        this.ERROR_THRESHOLD =  this.getErrorThreshold();
        // If code is unknown, log it normally (don't throttle unknowns).
        if (code === null) {
            this.LogConsoleErrors(error);
            return;
        }

        const now = Date.now();
        let tracker = this.twilioErrorMap.get(code);

        // First time we see this code, or the window has expired -> reset.
        if (!tracker || (now - tracker.lastOccurredAt) > this.ERROR_WINDOW_MS) {
            tracker = {
                count: 1,
                firstOccurredAt: now,
                lastOccurredAt: now,
                alertShown: false,
                loggingStopped: false
            };
            this.twilioErrorMap.set(code, tracker);

            // Log the first occurrence.
            this.LogConsoleErrors(error);
            return;
        }

        // Same code within the window -> increment.
        tracker.count++;
        tracker.lastOccurredAt = now;

        // Below threshold -> keep logging to DB.
        if (tracker.count < this.ERROR_THRESHOLD) {
            this.LogConsoleErrors(error);
            return;
        }

        // At threshold -> log ONE final "suppressed" entry + alert the user.
        if (tracker.count === this.ERROR_THRESHOLD) {
            this.LogConsoleErrors({
                ...error,
                message:
                    `[Suppressed] Twilio error ${code} occurred ${tracker.count} ` +
                    `times within ${this.ERROR_WINDOW_MS / 60000} minute(s). ` +
                    `Further logging stopped.`,
                suppressed: true
            });

            tracker.loggingStopped = true;

            if (!tracker.alertShown) {
                tracker.alertShown = true;
                this.alertUserToRelogin(code);
            }
            return;
        }

        // Above threshold -> do NOT send to DB anymore.
        console.warn(
            `[TwilioVoice] Error ${code} suppressed ` +
            `(count=${tracker.count}). Not logging to DB.`
        );
    }
    alertUserToRelogin(code: number): void {
        this.zone.run(() => {
            //this.showPhoneMessaging(
            //    `A Twilio connection error (code ${code}) has occurred repeatedly. ` +
            //    `Please log out and log in again to restore your softphone.`
            //);

            this.confirmDialogComponent
                .confirmdialog('', `A connection error (code ${code}) has occurred repeatedly. ` +
                    `Please log out and log in again to restore your softphone.`, 'OK', '')
                .then(confirmed => {
                    if (confirmed) {
                        // window.location.replace(window.location.protocol + "//" + window.location.host);
                    }
                });

            // Optionally mark device not ready so calls are not routed.
            //this.dialerService.setDeviceReady(false);
            //this.appService.setSoftPhoneStatus('Error - Please Relogin');
        });
    }
   
    private getErrorThreshold(): number {
        const raw = Utils.fetch('DefaultTwilioErrorOccurance');
        const value = parseInt(raw, 10);
        return Number.isFinite(value) && value > 0 ? value : 15;
    }
    private startErrorMapCleanup(): void {
        this.errorCleanupTimer =   setInterval(() => {
            const now = Date.now();

            this.twilioErrorMap.forEach((tracker, code) => {
                if ((now - tracker.lastOccurredAt) > this.ERROR_COOLDOWN_MS) {
                    this.twilioErrorMap.delete(code);
                    console.debug(
                        `[TwilioVoice] Error tracker reset for code ${code}.`
                    );
                }
            });
        }, this.ERROR_COOLDOWN_MS);
    }

  makeKey(source: string, code?: string | number, message?: string) {
    const m = (message || '').trim().slice(0, 500); // truncate long strings
    return `${m}`;
  }

  shouldSend1(key: string): boolean {
    const now = Date.now();
    const entry = this.state.get(key);
    if (!entry) {
      this.state.set(key, { lastSentAt: now });
      return true;
    }
    if (now - entry.lastSentAt >= this.windowMs) {
      entry.lastSentAt = now;
      return true;
    }
    return false; // suppress repeat within window
  }

  private shouldSend(key: string): boolean {
    const now = Date.now();

    // C) Optional: exponential backoff gate (comment this block out if you don't want adaptive suppression)
    //if (!this.checkBackoffAndMaybeUpdate(key, now)) {
    //    return false;
    //}

    // A) De-dup once per windowMs
    if (!this.checkDedupAndUpdate(key, now)) {
      return false;
    }

    // B) Burst cap per window
    //if (!this.checkBurstAndUpdate(key, now)) {
    //    return false;
    //}

    return true;
  }

  private windowMs = 60_000; // 60 seconds (adjust as needed)
  private opts: ErrorGateOptions = { windowMs: this.windowMs };
  private state = new Map<string, { lastSentAt: number }>();


  // OPTIONAL: adaptive backoff (comment out if you don't need it)
  private backoffBaseMs = 2_000;            // starts at 2s
  private backoffFactor = 2;                // doubles each repeat
  private backoffMaxMs = 60_000;            // cap at 60s
  private backoffResetQuietMs = 120_000;    // reset backoff after 2 minutes of silence

  private burstWindowMs = 60_000;           // burst window length
  private burstMaxSendsPerWindow = 1;       // "N-per-window" for each key; set to 1 for strict "one in 10s"


  // A) De-dup state: last sent time per key
  //private state = new Map<string, { lastSentAt: number }>();

  // B) Burst throttle state: timestamps of sends per key (sliding window)
  private burstState = new Map<string, number[]>();

  // C) Backoff state (optional)
  private backoffState = new Map<string, { lastSentAt: number; backoffMs: number }>();

  /**
   * A) De-dup gate: allow same key only once per `windowMs`.
   */
  private checkDedupAndUpdate(key: string, now: number): boolean {
    const entry = this.state.get(key);

    if (!entry) {
      this.state.set(key, { lastSentAt: now });
      // console.log('lastsent', new Date());
      return true;
    }
    if (now - entry.lastSentAt >= this.windowMs) {
      entry.lastSentAt = now;
      //console.log('lastsent', new Date(entry?.lastSentAt));
      return true;
    }
    return false; // repeated too soon
  }

  /**
   * B) Burst throttle: allow at most `burstMaxSendsPerWindow` sends per key within `burstWindowMs`.
   * If you want strict "no repeats within 10s", set `burstMaxSendsPerWindow = 1`.
   */
  private checkBurstAndUpdate(key: string, now: number): boolean {
    const arr = this.burstState.get(key) ?? [];
    // drop old timestamps outside the window
    const pruned = arr.filter(t => now - t < this.burstWindowMs);

    if (pruned.length < this.burstMaxSendsPerWindow) {
      pruned.push(now);
      this.burstState.set(key, pruned);
      return true;
    }

    this.burstState.set(key, pruned); // keep pruned list
    return false; // too many sends in the burst window
  }

  /**
   * C) Optional exponential backoff per key.
   * - First send allowed immediately (creates entry).
   * - If the same key fires again quickly, we require a growing quiet period
   *   (base -> base*2 -> base*4 ... up to max).
   * - If quiet for `backoffResetQuietMs`, we reset back to base.
   */
  private checkBackoffAndMaybeUpdate(key: string, now: number): boolean {
    // Comment this whole function body to disable backoff logic.
    const base = this.backoffBaseMs;
    const factor = this.backoffFactor;
    const max = this.backoffMaxMs;
    const resetQuiet = this.backoffResetQuietMs;

    let entry = this.backoffState.get(key);
    if (!entry) {
      // First time we see this key: allow and prime backoff for next time
      this.backoffState.set(key, { lastSentAt: now, backoffMs: base });
      return true;
    }

    // Reset backoff if quiet long enough
    if (now - entry.lastSentAt >= resetQuiet) {
      entry.backoffMs = base;
    }

    if (now - entry.lastSentAt >= entry.backoffMs) {
      // allow and step up backoff for next repeat
      entry.lastSentAt = now;
      entry.backoffMs = Math.min(entry.backoffMs * factor, max);
      this.backoffState.set(key, entry);
      return true;
    }

    // still within required quiet period ? suppress
    return false;
  }

  /**
   * (Optional) Housekeeping: call this every few minutes to prevent unbounded Map growth.
   * E.g., setInterval(() => this.gcGates(), 5 * 60 * 1000);
   */
  private gcGates(): void {
    const now = Date.now();
    const expireAfter = 30 * 60 * 1000; // 30 minutes idle

    // Clean de-dup map
    for (const [k, v] of this.state) {
      if (now - v.lastSentAt > expireAfter) this.state.delete(k);
    }
    // Clean burst map
    for (const [k, arr] of this.burstState) {
      const pruned = arr.filter(t => now - t < this.burstWindowMs);
      if (pruned.length === 0) this.burstState.delete(k);
      else this.burstState.set(k, pruned);
    }
    // Clean backoff map
    for (const [k, v] of this.backoffState) {
      if (now - v.lastSentAt > expireAfter) this.backoffState.delete(k);
    }
  }
    // TEMPORARY - remove after testing
    public testTwilioError(code: number, times: number): void {
        for (let i = 0; i < times; i++) {
            const fakeError = {
                code: code,
                message: `Simulated Twilio error ${code} (iteration ${i + 1})`
            };
            this.handleTwilioErrorLogging(fakeError);
        }
    }
    private handleAgentStatusDisconnect(data: unknown): void {
        console.log(
            'Softphone device failure detected. Changing agent status to disconnected.',
            data
        );
        if (this.waitingTimeout) {
            // clearTimeout(this.waitingTimeout);
            // this.waitingTimeout=null;
            this.Predictiveclose();
            this.setAllDialerWindowStatus(false, false, false);
            this.confirmDialogComponent
                .confirmdialog('Softphone Device Issue Detected', `Your softphone device failure has been detected.\n` +
                    `Click OK to automatically refresh the application and reconnect your softphone.`, 'OK', '')
                .then(confirmed => {
                    if (confirmed) {
                        window.location.reload();
                    }
                });
        } else {
            console.log('this.waitingTimeout', this.waitingTimeout);
        }

    }
  
}



interface ErrorGateOptions {
  windowMs: number;
}

interface TwilioErrorTracker {
    count: number;
    firstOccurredAt: number;   // epoch ms
    lastOccurredAt: number;    // epoch ms
    alertShown: boolean;
    loggingStopped: boolean;
}
